export const NotificationActiveIcon = (props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_694_9960)">
        <path
          d="M20.0204 24.4713C19.7883 24.7893 19.4845 25.048 19.1335 25.2263C18.7826 25.4047 18.3945 25.4976 18.0009 25.4976C17.6072 25.4976 17.2192 25.4047 16.8682 25.2263C16.5173 25.048 16.2134 24.7893 15.9814 24.4713M20.3817 22.235C21.9344 22.0512 23.4599 21.6847 24.9267 21.1433C23.6845 19.7673 22.9981 17.9787 23.0009 16.125C23.0009 14.5658 22.6853 13.1134 21.5364 11.9645C20.5987 11.0268 19.327 10.5 18.0009 10.5C16.6748 10.5 15.403 11.0268 14.4654 11.9645C13.3165 13.1134 13.0009 14.5658 13.0009 16.125C13.0034 17.9789 12.3167 19.7675 11.0742 21.1433C12.5184 21.6767 14.0409 22.0475 15.6201 22.235C17.2017 22.4226 18.8 22.4226 20.3817 22.235Z"
          stroke={props.color}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {props.showDot && (
          <circle
            cx="23"
            cy="12"
            r="4"
            fill="var(--secondaryColor)"
            stroke="var(--primaryColor)"
            strokeWidth="2"
            data-cy="NEW-NOTIFICATIONS-DOT"
          />
        )}
      </g>
      <defs>
        <clipPath id="clip0_694_9960">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ManPowerIcon = (props) => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M27.15 25.6498C27.15 28.4498 24.85 30.7498 22.05 30.7498C19.25 30.7498 16.95 28.4498 16.95 25.6498C16.95 25.3498 16.95 24.9498 17.05 24.6498H7.75V27.2498C7.75 27.8498 8.15 28.3498 8.75 28.3498L12.35 28.7498C12.45 28.7498 12.55 28.8498 12.65 28.9498C12.75 29.3498 12.95 29.7498 13.15 30.1498C13.25 30.2498 13.15 30.4498 13.15 30.5498L10.85 33.3498C10.45 33.8498 10.55 34.4498 10.95 34.8498L13.15 37.0498C13.55 37.4498 14.15 37.4498 14.65 37.1498L17.45 34.8498C17.55 34.7498 17.65 34.7498 17.75 34.8498C18.15 35.0498 18.55 35.2498 18.95 35.3498C19.05 35.3498 19.15 35.4498 19.15 35.6498L19.45 39.2498C19.55 39.8498 19.95 40.2498 20.55 40.2498H23.65C24.25 40.2498 24.75 39.8498 24.75 39.2498L25.15 35.6498C25.15 35.5498 25.25 35.4498 25.35 35.3498C25.75 35.2498 26.15 35.0498 26.55 34.8498C26.65 34.7498 26.85 34.7498 26.95 34.8498L29.75 37.1498C30.15 37.5498 30.85 37.4498 31.25 37.0498L33.45 34.8498C33.85 34.4498 33.85 33.7498 33.55 33.3498L31.05 30.4498C30.95 30.3498 30.95 30.2498 31.05 30.0498C31.25 29.6498 31.35 29.2498 31.55 28.8498C31.65 28.7498 31.75 28.6498 31.85 28.6498L35.45 28.2498C36.05 28.1498 36.45 27.7498 36.45 27.1498V24.5498H27.05C27.05 24.9498 27.15 25.3498 27.15 25.6498Z"
        fill={props.color || "#ECECEC"}
      />
      <path
        opacity="0.5"
        d="M35.1508 16.15C34.4508 12.05 31.9508 8.65 28.4508 6.75L27.8508 11.35C27.7508 12.15 27.0508 12.65 26.3508 12.65C26.2508 12.65 26.1508 12.65 26.0508 12.65C25.2508 12.55 24.7508 11.75 24.8508 10.95L25.6508 4.65C25.7508 4.15 25.3508 3.75 24.8508 3.75H19.1508C18.6508 3.75 18.3508 4.25 18.3508 4.65L19.1508 10.95C19.2508 11.75 18.7508 12.55 17.9508 12.65C17.8508 12.65 17.7508 12.65 17.6508 12.65C16.8508 12.65 16.2508 12.05 16.1508 11.35L15.5508 6.75C12.0508 8.65 9.55078 12.15 8.85078 16.15C7.55078 16.35 6.55078 17.45 6.55078 18.85V20.05C6.55078 20.65 7.05078 21.15 7.65078 21.15H36.3508C36.9508 21.15 37.4508 20.65 37.4508 20.05V18.85C37.4508 17.45 36.4508 16.35 35.1508 16.15Z"
        fill={props.color || "#ECECEC"}
      />
    </svg>
  );
};

export const StarIcon = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7781 5.88517C20.5994 3.91067 23.4007 3.91067 24.2221 5.88517L28.0391 15.0628L37.9464 15.8585C40.0804 16.029 40.9457 18.691 39.3196 20.0843L31.7717 26.5505L34.0762 36.2177C34.5731 38.3003 32.3089 39.9448 30.4829 38.8302L22.0001 33.6492L13.5173 38.8302C11.6913 39.9448 9.42709 38.2985 9.92392 36.2177L12.2284 26.5505L4.68059 20.0843C3.05442 18.691 3.91975 16.029 6.05375 15.8585L15.9611 15.0628L19.7781 5.88517Z"
        fill="#ECECEC"
      />
    </svg>
  );
};

export const CollapseIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 10H2.4"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M10 6L13.6016 6"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M6 10L6 13.6001"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M10 6L10 2.4"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ExpandIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.39844 13.6001L13.5984 2.4001"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M2.39844 13.6001H7.99844"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M13.6 2.3999H8"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M2.39844 13.6V8"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M13.6016 2.3999V7.9999"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const RadioBoxInActiveIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="6.7" stroke="#CFCFCF" strokeWidth="1.6" />
    </svg>
  );
};

export const RadioBoxActiveIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8"
        cy="8"
        r="5"
        stroke={props.color || "white"}
        strokeWidth="5"
      />
    </svg>
  );
};

export const CheckBoxInDeSelectIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.800781 2.79981C0.800781 1.69524 1.69621 0.799805 2.80078 0.799805H13.2008C14.3053 0.799805 15.2008 1.69524 15.2008 2.7998V13.1998C15.2008 14.3044 14.3054 15.1998 13.2008 15.1998H2.80078C1.69621 15.1998 0.800781 14.3044 0.800781 13.1998V2.79981ZM4.5 7.1C4.00294 7.1 3.6 7.50294 3.6 8C3.6 8.49706 4.00294 8.9 4.5 8.9L11.5 8.9C11.9971 8.9 12.4 8.49706 12.4 8C12.4 7.50294 11.9971 7.1 11.5 7.1L4.5 7.1Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const CheckBoxInActiveIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.69999"
        y="1.70005"
        width="12.6"
        height="12.6"
        rx="1.1"
        stroke={props.color || "white"}
        strokeWidth="1.8"
      />
    </svg>
  );
};

export const CheckBoxActiveIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.7998 0.800049C1.69524 0.800049 0.799805 1.69548 0.799805 2.80005V13.2C0.799805 14.3046 1.69524 15.2 2.79981 15.2H13.1998C14.3044 15.2 15.1998 14.3046 15.1998 13.2V2.80005C15.1998 1.69548 14.3044 0.800049 13.1998 0.800049H2.7998ZM12.1669 5.03368C12.4793 5.3461 12.4793 5.85263 12.1669 6.16505L7.36549 10.9665C7.18302 11.149 6.93434 11.2248 6.69678 11.1942C6.52755 11.1724 6.36395 11.0965 6.23396 10.9665L3.83324 8.56575C3.52082 8.25333 3.52082 7.7468 3.83324 7.43438C4.14566 7.12196 4.65219 7.12196 4.96461 7.43438L6.79973 9.2695L11.0356 5.03368C11.348 4.72126 11.8545 4.72126 12.1669 5.03368Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const CheckBoxSelectedAll = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clipRule="evenodd"
        d="M0.800781 2.79981C0.800781 1.69524 1.69621 0.799805 2.80078 0.799805H13.2008C14.3053 0.799805 15.2008 1.69524 15.2008 2.7998V13.1998C15.2008 14.3044 14.3054 15.1998 13.2008 15.1998H2.80078C1.69621 15.1998 0.800781 14.3044 0.800781 13.1998V2.79981ZM4.5 7.1C4.00294 7.1 3.6 7.50294 3.6 8C3.6 8.49706 4.00294 8.9 4.5 8.9L11.5 8.9C11.9971 8.9 12.4 8.49706 12.4 8C12.4 7.50294 11.9971 7.1 11.5 7.1L4.5 7.1Z"
        fill="var(--secondaryColor)"
      />
    </svg>
  );
};

export const CaptureImageIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_688_8668)">
        <path
          d="M4.66536 12.6666C4.31174 12.6666 3.9726 12.5261 3.72256 12.2761C3.47251 12.026 3.33203 11.6869 3.33203 11.3333"
          stroke="#0E0E0E"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33203 8.66659V7.33325"
          stroke="#0E0E0E"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33203 4.66659C3.33203 4.31296 3.47251 3.97382 3.72256 3.72378C3.9726 3.47373 4.31174 3.33325 4.66536 3.33325"
          stroke="#0E0E0E"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.33203 3.33325H8.66536"
          stroke="#0E0E0E"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.332 3.33325C11.6857 3.33325 12.0248 3.47373 12.2748 3.72378C12.5249 3.97382 12.6654 4.31296 12.6654 4.66659"
          stroke="#0E0E0E"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.668 7.33325V8.66659"
          stroke="#0E0E0E"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.668 11.3333V13.9999"
          stroke="#0E0E0E"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9987 12.6667H11.332"
          stroke="#0E0E0E"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.66536 12.6667H7.33203"
          stroke="#0E0E0E"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_688_8668">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ErrorIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.47396 6.82353C7.47396 6.5528 7.70948 6.33333 8 6.33333C8.29052 6.33333 8.52604 6.5528 8.52604 6.82353V8.78431C8.52604 9.05504 8.29052 9.27451 8 9.27451C7.70948 9.27451 7.47396 9.05504 7.47396 8.78431V6.82353Z"
        fill={props.color || "#FF0000"}
      />
      <path
        d="M8 9.86274C7.70948 9.86274 7.47396 10.0822 7.47396 10.3529C7.47396 10.6237 7.70948 10.8431 8 10.8431C8.29052 10.8431 8.52604 10.6237 8.52604 10.3529C8.52604 10.0822 8.29052 9.86274 8 9.86274Z"
        fill={props.color || "#FF0000"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7653 10.5962L13.7682 10.6009C14.4348 11.6837 13.58 13 12.2719 13H3.72807C2.41997 13 1.56522 11.6838 2.23184 10.6009L2.23474 10.5962L6.51054 3.7972C6.66259 3.55357 6.88045 3.35267 7.14088 3.21336C7.40278 3.07327 7.69912 3 8 3C8.30088 3 8.59723 3.07327 8.85912 3.21336C9.11958 3.35268 9.33745 3.55361 9.48949 3.79725L13.7653 10.5962ZM8.39884 4.38982L12.6731 11.1864C12.8483 11.471 12.627 11.8235 12.2719 11.8235H3.72807C3.37303 11.8235 3.15171 11.471 3.32692 11.1864L7.60116 4.38982C7.64132 4.32501 7.69936 4.27114 7.7694 4.23367C7.83945 4.19621 7.919 4.17647 8 4.17647C8.081 4.17647 8.16055 4.19621 8.2306 4.23367C8.30064 4.27114 8.35868 4.32501 8.39884 4.38982Z"
        fill={props.color || "#FF0000"}
      />
    </svg>
  );
};

export const ExportIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 7.73226C1 7.62233 1.08954 7.5332 1.2 7.5332H2.00052C2.11098 7.5332 2.20052 7.62233 2.20052 7.73226L2.20052 13.1069C2.20052 13.2168 2.29006 13.3059 2.40052 13.3059L13.5995 13.3059C13.7099 13.3059 13.7995 13.2168 13.7995 13.1069V7.73226C13.7995 7.62233 13.889 7.5332 13.9995 7.5332H14.8C14.9105 7.5332 15 7.62233 15 7.73226V14.3012C15 14.4112 14.9105 14.5003 14.8 14.5003L1.2 14.5003C1.08954 14.5003 1 14.4112 1 14.3012L1 7.73226Z"
        fill={props.color || "white"}
      />
      <path
        d="M11.5759 5.03106C11.6527 5.11014 11.6505 5.23616 11.571 5.31253L11.1394 5.72736C11.06 5.80373 10.9334 5.80153 10.8566 5.72245L8.5977 3.39435L8.47794 10.2223C8.47601 10.3323 8.38492 10.4198 8.27448 10.4179L7.67457 10.4075C7.56413 10.4056 7.47617 10.3149 7.47809 10.205L7.59785 3.37698L5.16713 5.71326C5.08768 5.78963 4.96106 5.78743 4.88433 5.70835L4.46755 5.27879C4.39082 5.19971 4.39303 5.07369 4.47249 4.99732L7.98732 1.61904C8.06677 1.54267 8.19338 1.54487 8.27011 1.62395L11.5759 5.03106Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const EyeCloseIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 11.6667C5.58182 11.6667 3.41818 10.2667 2.4 8H1C2.08182 10.9333 4.81818 13 8 13C11.1818 13 13.9182 10.9333 15 8H13.6C12.5818 10.2667 10.4182 11.6667 8 11.6667Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const EyeOpenIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 4.33333C5.58182 4.33333 3.41818 5.73333 2.4 8H1C2.08182 5.06667 4.81818 3 8 3C11.1818 3 13.9182 5.06667 15 8H13.6C12.5818 5.73333 10.4182 4.33333 8 4.33333Z"
        fill={props.color || "#4E4E4E"}
      />
      <circle cx="8" cy="10" r="2" fill={props.color || "#4E4E4E"} />
    </svg>
  );
};

export const RotateIcon = (props) => {
  return (
    <svg
      width={props.width || "14"}
      height={props.height || "16"}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6 1.8337C11.2234 0.646152 9.4897 -0.00254483 7.70033 0.000498944C6.00088 0.000374291 4.34933 0.583725 3.00266 1.66087C1.65613 2.73805 0.690298 4.24766 0.255917 5.95463C-0.178584 7.66172 -0.0573301 9.4702 0.600781 11.098C1.25901 12.726 2.4169 14.0819 3.89434 14.9545C5.37147 15.8272 7.08524 16.1675 8.76823 15.9226C10.4511 15.6776 12.0088 14.8609 13.1984 13.6C13.3328 13.4633 13.4087 13.276 13.4087 13.0806C13.4088 12.8851 13.3331 12.6978 13.1988 12.561C13.0645 12.4241 12.8828 12.3493 12.6947 12.3531C12.5066 12.357 12.328 12.4395 12.199 12.5818C11.6143 13.2058 10.9146 13.7011 10.1417 14.0384C9.36891 14.3758 8.53867 14.5482 7.70047 14.5454C6.35161 14.5454 5.03833 14.0956 3.95393 13.2623C2.86951 12.4291 2.07117 11.2559 1.67638 9.91603C1.28158 8.57619 1.31113 7.13989 1.76075 5.81864C2.21025 4.4975 3.05618 3.36095 4.17387 2.5765C5.29153 1.79206 6.622 1.40112 7.96961 1.46102C9.31715 1.52105 10.6106 2.02875 11.6597 2.90963H10.5001C10.25 2.90963 10.019 3.04817 9.89393 3.27318C9.7689 3.49818 9.7689 3.77553 9.89393 4.00052C10.019 4.22552 10.25 4.36407 10.5001 4.36407H13.3001C13.4857 4.36407 13.6637 4.28749 13.7949 4.15113C13.9263 4.01477 14 3.8297 14 3.63685V0.727844C14 0.468024 13.8665 0.227935 13.65 0.0980248C13.4334 -0.031885 13.1666 -0.031885 12.95 0.0980248C12.7335 0.227935 12.6 0.468028 12.6 0.727844V1.8337Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const SuccessIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "12"}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33339 11.3684C5.66067 11.7173 6.1913 11.7173 6.51858 11.3684L15.4074 1.89476C15.7347 1.54595 15.7347 0.980413 15.4074 0.631602C15.0802 0.282792 14.5495 0.282793 14.2223 0.631604L6.5186 8.8421C6.19132 9.19091 5.6607 9.19091 5.33342 8.8421L1.77781 5.05257C1.45053 4.70375 0.919908 4.70376 0.592628 5.05257C0.26535 5.40138 0.265347 5.96691 0.592624 6.31572L5.33339 11.3684Z"
        fill="#00a000"
      />
    </svg>
  );
};

export const CloseIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.width || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33337 12.6666L12.6667 3.33325"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M12.6667 12.6667L3.33337 3.33342"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SearchIcon = (props) => {
  return (
    <svg
      width={props.width || "18"}
      height={props.height || "18"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.54439 1C6.25003 1 4.98474 1.38389 3.90852 2.10313C2.8323 2.82237 1.99349 3.84465 1.49816 5.0407C1.00284 6.23675 0.873235 7.55285 1.12575 8.82257C1.37827 10.0923 2.00156 11.2586 2.91681 12.174C3.83206 13.0894 4.99816 13.7128 6.26764 13.9654C7.53713 14.218 8.85299 14.0884 10.0488 13.5929C11.2447 13.0975 12.2667 12.2585 12.9859 11.1821C13.705 10.1057 14.0888 8.84019 14.0888 7.54559C14.0887 5.80963 13.3991 4.14479 12.1719 2.91728C10.9446 1.68977 9.28004 1.00011 7.54439 1Z"
        stroke={props.color || "#404040"}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M12.4297 12.4288L17.0002 17.0002"
        stroke={props.color || "#404040"}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ValidIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.22275 11.5C6.96616 11.7478 6.55014 11.7478 6.29355 11.5L3.19238 8.5C2.93579 8.25218 2.93579 7.85038 3.19239 7.60256C3.44898 7.35473 3.865 7.35473 4.12159 7.60256L6.29357 9.7051C6.55016 9.95292 6.96618 9.95292 7.22277 9.7051L11.455 5.18587C11.7116 4.93805 12.1277 4.93804 12.3843 5.18587C12.6408 5.43369 12.6408 5.83549 12.3843 6.08331L7.22275 11.5Z"
        fill="#4E4E4E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14.8 8C14.8 11.7555 11.7555 14.8 8 14.8C4.24446 14.8 1.2 11.7555 1.2 8C1.2 4.24446 4.24446 1.2 8 1.2C11.7555 1.2 14.8 4.24446 14.8 8Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const InfoIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.3 10.1H8.7V11.5H7.3V10.1ZM7.3 4.5H8.7V8.7H7.3V4.5ZM8 1C4.129 1 1 4.15 1 8C1 9.85651 1.7375 11.637 3.05025 12.9497C3.70026 13.5998 4.47194 14.1154 5.32122 14.4672C6.17049 14.8189 7.08075 15 8 15C9.85651 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85651 15 8C15 7.08075 14.8189 6.17049 14.4672 5.32122C14.1154 4.47194 13.5998 3.70026 12.9497 3.05025C12.2997 2.40024 11.5281 1.88463 10.6788 1.53284C9.8295 1.18106 8.91925 1 8 1ZM8 13.6C6.51479 13.6 5.09041 13.01 4.0402 11.9598C2.99 10.9096 2.4 9.48521 2.4 8C2.4 6.51479 2.99 5.09041 4.0402 4.0402C5.09041 2.99 6.51479 2.4 8 2.4C9.48521 2.4 10.9096 2.99 11.9598 4.0402C13.01 5.09041 13.6 6.51479 13.6 8C13.6 9.48521 13.01 10.9096 11.9598 11.9598C10.9096 13.01 9.48521 13.6 8 13.6Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const ProfileIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6663 6.00016C10.6663 6.70741 10.3854 7.38568 9.88529 7.88578C9.3852 8.38588 8.70692 8.66683 7.99967 8.66683C7.29243 8.66683 6.61415 8.38588 6.11406 7.88578C5.61396 7.38568 5.33301 6.70741 5.33301 6.00016C5.33301 5.29292 5.61396 4.61464 6.11406 4.11454C6.61415 3.61445 7.29243 3.3335 7.99967 3.3335C8.70692 3.3335 9.3852 3.61445 9.88529 4.11454C10.3854 4.61464 10.6663 5.29292 10.6663 6.00016ZM9.33301 6.00016C9.33301 6.35378 9.19253 6.69292 8.94248 6.94297C8.69243 7.19302 8.3533 7.3335 7.99967 7.3335C7.64605 7.3335 7.30691 7.19302 7.05687 6.94297C6.80682 6.69292 6.66634 6.35378 6.66634 6.00016C6.66634 5.64654 6.80682 5.3074 7.05687 5.05735C7.30691 4.80731 7.64605 4.66683 7.99967 4.66683C8.3533 4.66683 8.69243 4.80731 8.94248 5.05735C9.19253 5.3074 9.33301 5.64654 9.33301 6.00016Z"
        fill={props.fill ? props.fill : "#404040"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00049 0.999756C4.13458 0.999756 1.00049 4.13385 1.00049 7.99976C1.00049 11.8657 4.13458 14.9998 8.00049 14.9998C11.8664 14.9998 15.0005 11.8657 15.0005 7.99976C15.0005 4.13385 11.8664 0.999756 8.00049 0.999756ZM2.27322 7.99976C2.27322 9.32976 2.72694 10.5541 3.4874 11.5265C4.02145 10.8251 4.71042 10.2568 5.50049 9.86577C6.29056 9.47477 7.16033 9.27172 8.04185 9.27248C8.91197 9.27166 9.7708 9.46945 10.5529 9.8508C11.335 10.2321 12.0197 10.787 12.5549 11.473C13.1063 10.7499 13.4776 9.9058 13.638 9.01068C13.7984 8.11555 13.7433 7.1951 13.4773 6.32547C13.2114 5.45585 12.7422 4.66206 12.1085 4.00978C11.4749 3.3575 10.695 2.86548 9.83346 2.57444C8.97191 2.2834 8.05343 2.2017 7.15404 2.3361C6.25464 2.4705 5.40017 2.81714 4.66134 3.34734C3.92251 3.87753 3.32055 4.57604 2.90527 5.38506C2.48999 6.19409 2.27333 7.09037 2.27322 7.99976ZM8.00049 13.727C6.68573 13.729 5.41066 13.2767 4.39103 12.4467C4.80144 11.8591 5.3477 11.3794 5.98334 11.0484C6.61897 10.7173 7.32517 10.5447 8.04185 10.5452C8.74959 10.5446 9.44725 10.7129 10.0769 11.0361C10.7065 11.3593 11.25 11.828 11.6621 12.4034C10.6346 13.2604 9.3385 13.7289 8.00049 13.727Z"
        fill={props.fill ? props.fill : "#404040"}
      />
    </svg>
  );
};

export const ProfileEditIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6507 6.54222L1.25978 8.23245C1.2463 8.29424 1.24676 8.35827 1.26114 8.41985C1.27551 8.48144 1.30344 8.53903 1.34287 8.58841C1.38231 8.6378 1.43226 8.67774 1.48908 8.70531C1.5459 8.73288 1.60814 8.74739 1.67127 8.74777C1.70069 8.75074 1.73033 8.75074 1.75974 8.74777L3.45713 8.35613L7.59935 4.21874L5.78191 2.40204L5.78057 2.40071L1.6507 6.54222ZM5.78148 3.43062L2.31299 6.90868L2.07732 7.92769L3.0904 7.69394L6.56954 4.21835L5.78148 3.43062ZM8.62602 3.1943C8.66551 3.15453 8.69679 3.10736 8.71806 3.05547C8.73934 3.00358 8.75019 2.94799 8.75 2.8919C8.74981 2.8358 8.73858 2.78029 8.71695 2.72855C8.69532 2.67681 8.66372 2.62985 8.62396 2.59035L7.41007 1.37421C7.33026 1.29466 7.22226 1.25 7.10969 1.25C6.99711 1.25 6.8891 1.29466 6.8093 1.37421L6.1345 2.05025L7.95118 3.87039L8.62602 3.1943Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const ProcedureEditIcon = (props) => {
  return (
    <>
      {!props.active ? (
        <svg
          width={props.width || "16"}
          height={props.height || "16"}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_324_1547)">
            <path
              d="M10.7059 2.91609L13.3529 5.56315M8.94118 15.269H16M1.88235 11.7396L1 15.269L4.52941 14.3867L14.7524 4.16374C15.0832 3.83281 15.269 3.38403 15.269 2.91609C15.269 2.44816 15.0832 1.99938 14.7524 1.66845L14.6006 1.51668C14.2697 1.18585 13.8209 1 13.3529 1C12.885 1 12.4362 1.18585 12.1053 1.51668L1.88235 11.7396Z"
              stroke={props.color || "#404040"}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_324_1547">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          width="26"
          height="30"
          viewBox="0 0 26 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2635_3444)">
            <path
              d="M15.5229 9.87997L18.12 12.4771M13.7914 22H20.7172M6.86572 18.5371L6 22L9.46287 21.1343L19.4931 11.1041C19.8177 10.7794 20 10.3391 20 9.87997C20 9.42085 19.8177 8.98054 19.4931 8.65584L19.3442 8.50694C19.0195 8.18235 18.5791 8 18.12 8C17.6609 8 17.2206 8.18235 16.8959 8.50694L6.86572 18.5371Z"
              stroke="white"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path d="M21 1H25V5" stroke="white" />
          <path d="M5 29H1V25" stroke="white" />
          <defs>
            <clipPath id="clip0_2635_3444">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(5 7)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export const DefaultUserProfileIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2Z"
        stroke={props.color || "#404040"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.27148 18.346C4.27148 18.346 6.50048 15.5 12.0005 15.5C17.5005 15.5 19.7305 18.346 19.7305 18.346M12.0005 12C12.7961 12 13.5592 11.6839 14.1218 11.1213C14.6844 10.5587 15.0005 9.79565 15.0005 9C15.0005 8.20435 14.6844 7.44129 14.1218 6.87868C13.5592 6.31607 12.7961 6 12.0005 6C11.2048 6 10.4418 6.31607 9.87916 6.87868C9.31655 7.44129 9.00048 8.20435 9.00048 9C9.00048 9.79565 9.31655 10.5587 9.87916 11.1213C10.4418 11.6839 11.2048 12 12.0005 12Z"
        stroke={props.color || "#404040"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DefaultCorporateProfileIcon = (props) => {
  return (
    <svg
      width={props.width || "48"}
      height={props.height || "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#F1F1F1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3684 10C20.4383 10 19.6842 10.7429 19.6842 11.6593V17.0519H15.6842C14.754 17.0519 14 17.7947 14 18.7111V38H19.6842V17.0519H23.4737C24.4038 17.0519 25.1579 17.7947 25.1579 18.7111V38H34V11.6593C34 10.7429 33.246 10 32.3158 10H21.3684Z"
        fill="#E5E5E5"
      />
    </svg>
  );
};

export const ExitIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.3333 4.66667L10.3933 5.60667L12.1133 7.33333H5.33325V8.66667H12.1133L10.3933 10.3867L11.3333 11.3333L14.6666 8L11.3333 4.66667ZM2.66659 3.33333H7.99992V2H2.66659C1.93325 2 1.33325 2.6 1.33325 3.33333V12.6667C1.33325 13.4 1.93325 14 2.66659 14H7.99992V12.6667H2.66659V3.33333Z"
        fill={props.fill ? props.fill : "#404040"}
      />
    </svg>
  );
};

export const ArrowIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 12 12"
      fill={props.color || "white"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4243 4.42417C10.6586 4.18985 10.6586 3.80995 10.4243 3.57564C10.19 3.34132 9.81008 3.34132 9.57576 3.57564L5.99996 7.15143L2.42417 3.57564C2.18985 3.34132 1.80995 3.34132 1.57564 3.57564C1.34132 3.80995 1.34132 4.18985 1.57564 4.42417L5.57564 8.42417C5.69235 8.54088 5.84519 8.59946 5.99816 8.5999C6.15234 8.60037 6.30666 8.5418 6.42429 8.42417L10.4243 4.42417Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const BackArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.80859 10L15.9197 10"
      stroke="var(--tertiaryColor6)"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M4.08008 10L8.70971 14.6296"
      stroke="var(--tertiaryColor6)"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M4.08008 10.0007L8.70971 5.37109"
      stroke="var(--tertiaryColor6)"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const ClockIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M8 15.5C6.61553 15.5 5.26216 15.0895 4.11101 14.3203C2.95987 13.5511 2.06266 12.4579 1.53285 11.1788C1.00303 9.8997 0.86441 8.49224 1.13451 7.13437C1.4046 5.7765 2.07129 4.52922 3.05026 3.55026C4.02922 2.57129 5.2765 1.9046 6.63437 1.63451C7.99224 1.36441 9.3997 1.50303 10.6788 2.03285C11.9579 2.56266 13.0511 3.45987 13.8203 4.61101C14.5895 5.76216 15 7.11553 15 8.5C15 10.3565 14.2625 12.137 12.9497 13.4497C11.637 14.7625 9.85652 15.5 8 15.5ZM8 2.5C6.81332 2.5 5.65328 2.8519 4.66658 3.51119C3.67989 4.17047 2.91085 5.10755 2.45673 6.2039C2.0026 7.30026 1.88378 8.50666 2.11529 9.67054C2.3468 10.8344 2.91825 11.9035 3.75736 12.7426C4.59648 13.5818 5.66558 14.1532 6.82946 14.3847C7.99335 14.6162 9.19975 14.4974 10.2961 14.0433C11.3925 13.5892 12.3295 12.8201 12.9888 11.8334C13.6481 10.8467 14 9.68669 14 8.5C14 6.9087 13.3679 5.38258 12.2426 4.25736C11.1174 3.13214 9.5913 2.5 8 2.5Z"
        fill={props.color ? props.color : "#404040"}
      />
      <path
        d="M10.295 11.5L7.5 8.705V4H8.5V8.29L11 10.795L10.295 11.5Z"
        fill={props.color ? props.color : "#404040"}
      />
    </svg>
  );
};

export const AddIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12.6749V3.32495"
        stroke={props.color || "#0E0E0E"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M12.6748 8L3.32483 8"
        stroke={props.color || "#0E0E0E"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const DownloadIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 9.62244L8 3.33337"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M13.3333 10.6666V12C13.3333 12.3682 13.0348 12.6666 12.6666 12.6666L3.33329 12.6666C2.9651 12.6666 2.66663 12.3681 2.66663 12L2.66663 10.6666"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9.62236L5 7.04956"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M11 7.04956L8 9.62236"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const PlayIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.92413 13C4.77061 12.9997 4.61981 12.956 4.48657 12.8731C4.18653 12.6883 4 12.3296 4 11.9402V4.05983C4 3.66934 4.18653 3.31173 4.48657 3.12695C4.62299 3.04174 4.77796 2.99792 4.93529 3.00008C5.09263 3.00223 5.24654 3.05027 5.38094 3.13918L11.5781 7.17068C11.7072 7.25869 11.8137 7.38091 11.8875 7.52588C11.9613 7.67084 12 7.8338 12 7.99948C12 8.16516 11.9613 8.32812 11.8875 8.47308C11.8137 8.61805 11.7072 8.74027 11.5781 8.82828L5.37994 12.8609C5.2424 12.9512 5.08485 12.9993 4.92413 13Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const JamMenuIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 8H15M8 13H15M1 3H8"
        stroke={props.color || "#404040"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FilterIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3H15M1 8H10.3333M1 13H4.73333"
        stroke={props.color || "#404040"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EnterArrowIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "72"}
      height={props.height || "72"}
      viewBox="0 0 72 72"
      fill="none"
    >
      <path
        d="M61 36.4286L11 36.4286M61 36.4286L39.5714 57.8571M61 36.4286L39.5714 15"
        stroke={props.color || "white"}
        strokeWidth="5.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PauseIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 3H5V13H3V3Z" fill={props.color || "white"} />
      <path d="M10 3H12V13H10V3Z" fill={props.color || "white"} />
    </svg>
  );
};

export const MicIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99999 7.46154C9.99999 8.05444 9.78094 8.61628 9.40136 9.02506C9.02294 9.43259 8.51797 9.65385 7.99999 9.65385C7.48202 9.65385 6.97705 9.43259 6.59863 9.02506C6.21905 8.61628 6 8.05444 6 7.46154V3.69231C6 3.09941 6.21905 2.53756 6.59863 2.12878C6.97705 1.72125 7.48202 1.5 7.99999 1.5C8.51797 1.5 9.02294 1.72125 9.40136 2.12878C9.78094 2.53756 9.99999 3.09941 9.99999 3.69231V7.46154Z"
        fill={props.color || "white"}
        stroke={props.color || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 8C13.0013 8.6368 12.8858 9.26762 12.6601 9.85622C12.4345 10.4448 12.103 10.9796 11.6849 11.4299C11.2668 11.8802 10.7702 12.2371 10.2236 12.4802C9.67707 12.7232 9.09132 12.8476 8.5 12.8462H7.5C6.90868 12.8476 6.32293 12.7232 5.77637 12.4802C5.22981 12.2371 4.73321 11.8802 4.31509 11.4299C3.89696 10.9796 3.56555 10.4448 3.33987 9.85622C3.11419 9.26762 2.99869 8.6368 3.00001 8M8 12.8462V15"
        stroke={props.color || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StopIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="12" height="12" fill="white" />
    </svg>
  );
};

export const CalendarIcon = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6875 14H1.3125C0.58625 14 0 13.4137 0 12.6875V2.1875C0 1.46125 0.58625 0.875 1.3125 0.875H12.6875C13.4137 0.875 14 1.46125 14 2.1875V12.6875C14 13.4137 13.4137 14 12.6875 14ZM1.3125 1.75C1.0675 1.75 0.875 1.9425 0.875 2.1875V12.6875C0.875 12.9325 1.0675 13.125 1.3125 13.125H12.6875C12.9325 13.125 13.125 12.9325 13.125 12.6875V2.1875C13.125 1.9425 12.9325 1.75 12.6875 1.75H1.3125Z"
        fill={props.color || "#404040"}
      />
      <path
        d="M3.9375 3.5C3.6925 3.5 3.5 3.3075 3.5 3.0625V0.4375C3.5 0.1925 3.6925 0 3.9375 0C4.1825 0 4.375 0.1925 4.375 0.4375V3.0625C4.375 3.3075 4.1825 3.5 3.9375 3.5ZM10.0625 3.5C9.8175 3.5 9.625 3.3075 9.625 3.0625V0.4375C9.625 0.1925 9.8175 0 10.0625 0C10.3075 0 10.5 0.1925 10.5 0.4375V3.0625C10.5 3.3075 10.3075 3.5 10.0625 3.5ZM13.5625 5.25H0.4375C0.1925 5.25 0 5.0575 0 4.8125C0 4.5675 0.1925 4.375 0.4375 4.375H13.5625C13.8075 4.375 14 4.5675 14 4.8125C14 5.0575 13.8075 5.25 13.5625 5.25Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const ProcedureTitleIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.354 5.104C7.44789 5.01011 7.50063 4.88278 7.50063 4.75C7.50063 4.61722 7.44789 4.48989 7.354 4.396C7.26011 4.30211 7.13278 4.24937 7 4.24937C6.86722 4.24937 6.73989 4.30211 6.646 4.396L5.234 5.808L4.837 5.446C4.73836 5.36169 4.6108 5.31903 4.48129 5.32703C4.35177 5.33504 4.23044 5.39308 4.14293 5.4889C4.05543 5.58472 4.0086 5.7108 4.01234 5.84051C4.01609 5.97022 4.07011 6.09339 4.163 6.184L4.913 6.869C5.00803 6.95552 5.13272 7.00213 5.2612 6.99915C5.38968 6.99617 5.51208 6.94383 5.603 6.853L7.353 5.103L7.354 5.104ZM7.354 9.396C7.40056 9.44245 7.43751 9.49762 7.46271 9.55837C7.48792 9.61911 7.50089 9.68423 7.50089 9.75C7.50089 9.81577 7.48792 9.88089 7.46271 9.94163C7.43751 10.0024 7.40056 10.0576 7.354 10.104L5.604 11.854C5.51291 11.945 5.39023 11.9973 5.26151 12.0001C5.13279 12.0029 5.00796 11.9559 4.913 11.869L4.163 11.184C4.07011 11.0934 4.01609 10.9702 4.01234 10.8405C4.0086 10.7108 4.05543 10.5847 4.14293 10.4889C4.23044 10.3931 4.35177 10.335 4.48129 10.327C4.6108 10.319 4.73836 10.3617 4.837 10.446L5.234 10.809L6.646 9.396C6.69245 9.34944 6.74762 9.31249 6.80837 9.28729C6.86911 9.26208 6.93423 9.24911 7 9.24911C7.06577 9.24911 7.13089 9.26208 7.19163 9.28729C7.25238 9.31249 7.30755 9.34944 7.354 9.396ZM9 10C8.86739 10 8.74021 10.0527 8.64645 10.1464C8.55268 10.2402 8.5 10.3674 8.5 10.5C8.5 10.6326 8.55268 10.7598 8.64645 10.8536C8.74021 10.9473 8.86739 11 9 11H11.5C11.6326 11 11.7598 10.9473 11.8536 10.8536C11.9473 10.7598 12 10.6326 12 10.5C12 10.3674 11.9473 10.2402 11.8536 10.1464C11.7598 10.0527 11.6326 10 11.5 10H9ZM8.5 5.5C8.5 5.36739 8.55268 5.24021 8.64645 5.14645C8.74021 5.05268 8.86739 5 9 5H11.5C11.6326 5 11.7598 5.05268 11.8536 5.14645C11.9473 5.24021 12 5.36739 12 5.5C12 5.63261 11.9473 5.75979 11.8536 5.85355C11.7598 5.94732 11.6326 6 11.5 6H9C8.86739 6 8.74021 5.94732 8.64645 5.85355C8.55268 5.75979 8.5 5.63261 8.5 5.5ZM4 1C3.20435 1 2.44129 1.31607 1.87868 1.87868C1.31607 2.44129 1 3.20435 1 4V12C1 12.7956 1.31607 13.5587 1.87868 14.1213C2.44129 14.6839 3.20435 15 4 15H12C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12V4C15 3.20435 14.6839 2.44129 14.1213 1.87868C13.5587 1.31607 12.7956 1 12 1H4ZM2 4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H12C12.5304 2 13.0391 2.21071 13.4142 2.58579C13.7893 2.96086 14 3.46957 14 4V12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14H4C3.46957 14 2.96086 13.7893 2.58579 13.4142C2.21071 13.0391 2 12.5304 2 12V4Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const RefreshIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4583 4.79167C13.4451 2.65389 11.0545 1 8.5 1C7.64641 1 6.80117 1.16813 6.01256 1.49478C5.22394 1.82144 4.50739 2.30023 3.90381 2.90381C3.30023 3.50739 2.82144 4.22394 2.49478 5.01256C2.16813 5.80117 2 6.64641 2 7.5C2 8.35359 2.16813 9.19883 2.49478 9.98744C2.82144 10.7761 3.30023 11.4926 3.90381 12.0962C4.50739 12.6998 5.22394 13.1786 6.01256 13.5052C6.80117 13.8319 7.64641 14 8.5 14C10.2239 14 11.8772 13.3152 13.0962 12.0962C14.3152 10.8772 14.5 10.5 15 9M15 1V5.33333H10.6667"
        stroke={props.color || "white"}
        strokeWidth="1.2"
      />
    </svg>
  );
};

export const LocationIcon = (props) => {
  return (
    <svg
      width={props.width || "72"}
      height={props.height || "72"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9999 14.1253L8.48066 13.5835C9.02618 12.9588 9.51685 12.366 9.95342 11.8022L10.3138 11.3268C11.8186 9.29934 12.5713 7.6902 12.5713 6.50087C12.5713 3.9622 10.5248 1.9043 7.9999 1.9043C5.47494 1.9043 3.42847 3.9622 3.42847 6.50087C3.42847 7.6902 4.18123 9.29934 5.68599 11.3268L6.04637 11.8022C6.66918 12.6002 7.32079 13.3746 7.9999 14.1253Z"
        stroke={props.color || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99998 8.38081C9.05195 8.38081 9.90474 7.52802 9.90474 6.47605C9.90474 5.42408 9.05195 4.57129 7.99998 4.57129C6.94801 4.57129 6.09521 5.42408 6.09521 6.47605C6.09521 7.52802 6.94801 8.38081 7.99998 8.38081Z"
        stroke={props.color || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TickIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M6.875 22.375L15.625 31.125L33.125 12.375"
        stroke={props.color || "#404040"}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ImageFallbackIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g opacity="0.6" clipPath="url(#clip0_1268_3459)">
        <path
          d="M14.224 1.77832H1.77951C1.54377 1.77832 1.31767 1.87197 1.15097 2.03867C0.984275 2.20537 0.890625 2.43146 0.890625 2.66721V13.3339C0.890625 13.5696 0.984275 13.7957 1.15097 13.9624C1.31767 14.1291 1.54377 14.2228 1.77951 14.2228H14.224C14.4597 14.2228 14.6858 14.1291 14.8525 13.9624C15.0192 13.7957 15.1128 13.5696 15.1128 13.3339V2.66721C15.1128 2.43146 15.0192 2.20537 14.8525 2.03867C14.6858 1.87197 14.4597 1.77832 14.224 1.77832ZM1.77951 13.3339V2.66721H14.224V13.3339H1.77951Z"
          fill="#404040"
        />
        <path
          d="M3.96615 6.22233C4.22985 6.22233 4.48764 6.14413 4.70691 5.99762C4.92617 5.85112 5.09707 5.64288 5.19799 5.39924C5.2989 5.15561 5.32531 4.88752 5.27386 4.62888C5.22241 4.37024 5.09542 4.13266 4.90895 3.94619C4.72248 3.75972 4.48491 3.63273 4.22627 3.58128C3.96762 3.52984 3.69954 3.55624 3.4559 3.65716C3.21227 3.75808 3.00403 3.92897 2.85752 4.14824C2.71101 4.3675 2.63281 4.62529 2.63281 4.889C2.63281 5.24262 2.77329 5.58176 3.02334 5.83181C3.27339 6.08186 3.61252 6.22233 3.96615 6.22233ZM3.96615 4.17789C4.10698 4.17701 4.2449 4.21796 4.36242 4.29556C4.47995 4.37317 4.57178 4.48392 4.62629 4.61377C4.68079 4.74363 4.69551 4.88675 4.66858 5.02498C4.64164 5.16322 4.57427 5.29034 4.475 5.39024C4.37572 5.49013 4.24903 5.5583 4.11096 5.5861C3.9729 5.6139 3.82969 5.60008 3.6995 5.54639C3.5693 5.4927 3.45797 5.40156 3.37964 5.28453C3.3013 5.16749 3.25948 5.02983 3.25948 4.889C3.26064 4.70194 3.33547 4.52287 3.46775 4.3906C3.60002 4.25832 3.77909 4.1835 3.96615 4.18233V4.17789Z"
          fill="#404040"
        />
        <path
          d="M10.1261 6.83139L7.72615 9.23139L5.94837 7.45361C5.8651 7.37083 5.75245 7.32437 5.63503 7.32437C5.51762 7.32437 5.40497 7.37083 5.3217 7.45361L2.63281 10.1781V11.4358L5.65059 8.41806L7.11281 9.85806L5.44615 11.5247H6.66837L10.4239 7.76917L13.335 10.6669V9.41361L10.7528 6.83139C10.6695 6.74861 10.5569 6.70215 10.4395 6.70215C10.3221 6.70215 10.2094 6.74861 10.1261 6.83139Z"
          fill="#404040"
        />
      </g>
      <defs>
        <clipPath id="clip0_1268_3459">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ErrorBoundaryFallBack = () => {
  return (
    <svg
      width="147"
      height="156"
      viewBox="0 0 147 156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.56294 132.768C3.97014 130.648 5.47455 128.904 7.5123 128.191L21.646 123.243C25.0618 122.048 28.7572 124.093 29.5583 127.622L34.0771 147.529C35.0102 151.639 31.5658 155.424 27.3857 154.88L6.3846 152.15C2.92267 151.7 0.555873 148.425 1.21431 144.997L3.56294 132.768Z"
        fill="#F1F1F1"
      />
      <path
        d="M128.913 12.6104C128.491 8.16241 132.863 4.80178 137.052 6.35423L139.977 7.43804C141.626 8.04898 142.928 9.3459 143.546 10.9922L144.406 13.2843C145.748 16.8631 143.483 20.7759 139.711 21.3936L136.3 21.9522C132.838 22.5191 129.619 20.0372 129.287 16.5449L128.913 12.6104Z"
        fill="#F1F1F1"
      />
      <path
        d="M128.581 117.383C128.313 114.445 131.226 112.249 133.977 113.314C135.052 113.731 135.894 114.594 136.284 115.679L136.383 115.955C137.226 118.305 135.743 120.846 133.282 121.267C130.974 121.662 128.819 120.006 128.607 117.674L128.581 117.383Z"
        fill="#F1F1F1"
      />
      <path
        d="M18.8427 13.6181C18.4421 10.4723 21.3737 7.9331 24.4301 8.77845L27.072 9.50915C28.133 9.80259 29.0203 10.5311 29.5146 11.5147C30.7252 13.9236 29.1822 16.8044 26.5061 17.1315L23.7853 17.4641C21.3602 17.7605 19.1513 16.0417 18.8427 13.6181Z"
        fill="#F1F1F1"
      />
      <path
        d="M37.8677 31.6791C37.0845 27.6202 40.6294 24.0445 44.6949 24.7926L107.114 36.279C110.262 36.8582 112.365 39.8514 111.844 43.0089L106.384 76.0969C106.304 76.5809 106.282 77.0726 106.317 77.5619L108.123 102.726C108.362 106.054 105.781 108.913 102.446 109.014L49.7149 110.62C46.4039 110.721 43.6651 108.065 43.6651 104.752V62.3188C43.6651 61.9214 43.6272 61.5248 43.5519 61.1346L37.8677 31.6791Z"
        fill="#F1F1F1"
        stroke="#959595"
        strokeWidth="0.378774"
      />
      <circle cx="62" cy="65" r="8" fill="#E5E5E5" />
      <circle cx="67.5" cy="70.5" r="2.5" fill="#959595" />
      <circle cx="87" cy="65" r="8" fill="#E5E5E5" />
      <circle cx="81.5" cy="70.5" r="2.5" fill="#959595" />
      <path
        d="M58 95C62.9998 91.2645 76.81 80.8642 91 89.0827"
        stroke="#959595"
        strokeWidth="0.757547"
      />
      <path
        d="M68 35.3333L71.6 29L74 29.6667L69.5 35.3333L73.4 41L70.4 50L72.8 41L68 35.3333Z"
        fill="#959595"
      />
    </svg>
  );
};

export const FolderIcon = (props) => {
  return (
    <svg
      width={props.width || "24"}
      height={props.height || "25"}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M22.1538 6.19232H12.3819L9.23077 3.04116C9.05996 2.86899 8.85663 2.73248 8.6326 2.63958C8.40856 2.54668 8.1683 2.49923 7.92577 2.50001H1.84615C1.35652 2.50001 0.886947 2.69451 0.540726 3.04074C0.194505 3.38696 0 3.85653 0 4.34616V21.0331C0.000610604 21.5036 0.187774 21.9546 0.520447 22.2873C0.85312 22.6199 1.30415 22.8071 1.77462 22.8077H22.2565C22.7187 22.8071 23.1618 22.6232 23.4887 22.2964C23.8155 21.9695 23.9994 21.5264 24 21.0642V8.03847C24 7.54884 23.8055 7.07926 23.4593 6.73304C23.1131 6.38682 22.6435 6.19232 22.1538 6.19232ZM1.84615 4.34616H7.92577L9.77192 6.19232H1.84615V4.34616ZM22.1538 20.9615H1.84615V8.03847H22.1538V20.9615Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const TextWithWrongIcon = (props) => {
  return (
    <svg
      width={props.width || "30"}
      height={props.height || "28"}
      viewBox="0 0 30 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 8.07143C18 8.26867 17.8321 8.42857 17.625 8.42857H6.375C6.16789 8.42857 6 8.26867 6 8.07143V7.35714C6 7.1599 6.16789 7 6.375 7H17.625C17.8321 7 18 7.1599 18 7.35714V8.07143Z"
        fill={props.color || "#404040"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 12.3571C15 12.5544 14.8321 12.7143 14.625 12.7143H6.375C6.16789 12.7143 6 12.5544 6 12.3571V11.6429C6 11.4456 6.16789 11.2857 6.375 11.2857H14.625C14.8321 11.2857 15 11.4456 15 11.6429V12.3571Z"
        fill={props.color || "#404040"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 16.6429C10.5 16.8401 10.3321 17 10.125 17H6.375C6.16789 17 6 16.8401 6 16.6429V15.9286C6 15.7313 6.16789 15.5714 6.375 15.5714H10.125C10.3321 15.5714 10.5 15.7313 10.5 15.9286V16.6429Z"
        fill={props.color || "#404040"}
      />
      <path
        d="M16.2641 1.14628C18.5844 3.47138 21.0467 6.07565 21.8517 6.89963C21.9464 6.99659 21.9987 7.12653 21.9965 7.26206L21.7417 22.5084C21.7371 22.7812 21.5146 23 21.2418 23H2.5C2.22386 23 2 22.7761 2 22.5V1.5C2 1.22386 2.22386 1 2.5 1H15.9109C16.0434 1 16.1704 1.05244 16.2641 1.14628Z"
        stroke={props.color || "#404040"}
        strokeWidth="1.7"
      />
      <rect x="14" y="12" width="16" height="16" rx="8" fill="#FF4C4C" />
      <path
        d="M19.1259 17.1259C19.1657 17.086 19.213 17.0543 19.265 17.0327C19.3171 17.0111 19.3729 17 19.4292 17C19.4856 17 19.5414 17.0111 19.5935 17.0327C19.6455 17.0543 19.6928 17.086 19.7326 17.1259L22.0001 19.3942L24.2676 17.1259C24.3075 17.086 24.3548 17.0544 24.4068 17.0329C24.4589 17.0113 24.5146 17.0002 24.571 17.0002C24.6273 17.0002 24.6831 17.0113 24.7352 17.0329C24.7872 17.0544 24.8345 17.086 24.8743 17.1259C24.9142 17.1657 24.9458 17.213 24.9673 17.2651C24.9889 17.3171 25 17.3729 25 17.4292C25 17.4856 24.9889 17.5414 24.9673 17.5934C24.9458 17.6455 24.9142 17.6928 24.8743 17.7326L22.606 20.0001L24.8743 22.2676C24.9142 22.3075 24.9458 22.3548 24.9673 22.4068C24.9889 22.4589 25 22.5146 25 22.571C25 22.6273 24.9889 22.6831 24.9673 22.7352C24.9458 22.7872 24.9142 22.8345 24.8743 22.8743C24.8345 22.9142 24.7872 22.9458 24.7352 22.9673C24.6831 22.9889 24.6273 23 24.571 23C24.5146 23 24.4589 22.9889 24.4068 22.9673C24.3548 22.9458 24.3075 22.9142 24.2676 22.8743L22.0001 20.606L19.7326 22.8743C19.6928 22.9142 19.6455 22.9458 19.5934 22.9673C19.5414 22.9889 19.4856 23 19.4292 23C19.3729 23 19.3171 22.9889 19.2651 22.9673C19.213 22.9458 19.1657 22.9142 19.1259 22.8743C19.086 22.8345 19.0544 22.7872 19.0329 22.7352C19.0113 22.6831 19.0002 22.6273 19.0002 22.571C19.0002 22.5146 19.0113 22.4589 19.0329 22.4068C19.0544 22.3548 19.086 22.3075 19.1259 22.2676L21.3942 20.0001L19.1259 17.7326C19.086 17.6928 19.0543 17.6455 19.0327 17.5935C19.0111 17.5414 19 17.4856 19 17.4292C19 17.3729 19.0111 17.3171 19.0327 17.265C19.0543 17.213 19.086 17.1657 19.1259 17.1259Z"
        fill="white"
      />
    </svg>
  );
};

export const TextWithTickIcon = (props) => {
  return (
    <svg
      width={props.width || "30"}
      height={props.height || "28"}
      viewBox="0 0 30 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 8.07143C18 8.26867 17.8321 8.42857 17.625 8.42857H6.375C6.16789 8.42857 6 8.26867 6 8.07143V7.35714C6 7.1599 6.16789 7 6.375 7H17.625C17.8321 7 18 7.1599 18 7.35714V8.07143Z"
        fill={props.color || "#404040"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 12.3571C15 12.5544 14.8321 12.7143 14.625 12.7143H6.375C6.16789 12.7143 6 12.5544 6 12.3571V11.6429C6 11.4456 6.16789 11.2857 6.375 11.2857H14.625C14.8321 11.2857 15 11.4456 15 11.6429V12.3571Z"
        fill={props.color || "#404040"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 16.6429C10.5 16.8401 10.3321 17 10.125 17H6.375C6.16789 17 6 16.8401 6 16.6429V15.9286C6 15.7313 6.16789 15.5714 6.375 15.5714H10.125C10.3321 15.5714 10.5 15.7313 10.5 15.9286V16.6429Z"
        fill={props.color || "#404040"}
      />
      <path
        d="M16.2641 1.14628C18.5844 3.47138 21.0467 6.07565 21.8517 6.89963C21.9464 6.99659 21.9987 7.12653 21.9965 7.26206L21.7417 22.5084C21.7371 22.7812 21.5146 23 21.2418 23H2.5C2.22386 23 2 22.7761 2 22.5V1.5C2 1.22386 2.22386 1 2.5 1H15.9109C16.0434 1 16.1704 1.05244 16.2641 1.14628Z"
        stroke={props.color || "#404040"}
        strokeWidth="1.7"
      />
      <rect x="14" y="12" width="16" height="16" rx="8" fill="#00AF3C" />
      <path
        d="M25.5145 17.3154C25.6887 17.4896 25.6887 17.7721 25.5145 17.9464L20.8144 22.6464C20.6191 22.8417 20.3026 22.8417 20.1073 22.6464L18.3156 20.8548C18.1413 20.6805 18.1413 20.3978 18.3156 20.2235C18.4898 20.0494 18.7721 20.0492 18.9465 20.2231L20.4609 21.7338L24.8836 17.3152C25.0579 17.1411 25.3403 17.1412 25.5145 17.3154Z"
        fill="white"
      />
    </svg>
  );
};

export const FolderWithTickIcon = (props) => {
  return (
    <svg
      width={props.width || "30"}
      height={props.height || "28"}
      viewBox="0 0 30 28"
      fill="none"
    >
      <path
        d="M22.1538 5.69232H12.3819L9.23077 2.54116C9.05996 2.36899 8.85663 2.23248 8.6326 2.13958C8.40856 2.04668 8.1683 1.99923 7.92577 2.00001H1.84615C1.35652 2.00001 0.886947 2.19451 0.540726 2.54074C0.194505 2.88696 0 3.35653 0 3.84616V20.5331C0.000610604 21.0036 0.187774 21.4546 0.520447 21.7873C0.85312 22.1199 1.30415 22.3071 1.77462 22.3077H22.2565C22.7187 22.3071 23.1618 22.1232 23.4887 21.7964C23.8155 21.4695 23.9994 21.0264 24 20.5642V7.53847C24 7.04884 23.8055 6.57926 23.4593 6.23304C23.1131 5.88682 22.6435 5.69232 22.1538 5.69232ZM1.84615 3.84616H7.92577L9.77192 5.69232H1.84615V3.84616ZM22.1538 20.4615H1.84615V7.53847H22.1538V20.4615Z"
        fill={props.color || "#404040"}
      />
      <rect x="14" y="12" width="16" height="16" rx="8" fill="#00AF3C" />
      <path
        d="M25.5145 17.3154C25.6887 17.4896 25.6887 17.7721 25.5145 17.9464L20.8144 22.6464C20.6191 22.8417 20.3026 22.8417 20.1073 22.6464L18.3156 20.8548C18.1413 20.6805 18.1413 20.3978 18.3156 20.2235C18.4898 20.0494 18.7721 20.0492 18.9465 20.2231L20.4609 21.7338L24.8836 17.3152C25.0579 17.1411 25.3403 17.1412 25.5145 17.3154Z"
        fill="white"
      />
    </svg>
  );
};

export const FolderWithWrongIcon = (props) => {
  return (
    <svg
      width={props.width || "30"}
      height={props.height || "28"}
      viewBox="0 0 30 28"
      fill="none"
    >
      <path
        d="M22.1538 5.69232H12.3819L9.23077 2.54116C9.05996 2.36899 8.85663 2.23248 8.6326 2.13958C8.40856 2.04668 8.1683 1.99923 7.92577 2.00001H1.84615C1.35652 2.00001 0.886947 2.19451 0.540726 2.54074C0.194505 2.88696 0 3.35653 0 3.84616V20.5331C0.000610604 21.0036 0.187774 21.4546 0.520447 21.7873C0.85312 22.1199 1.30415 22.3071 1.77462 22.3077H22.2565C22.7187 22.3071 23.1618 22.1232 23.4887 21.7964C23.8155 21.4695 23.9994 21.0264 24 20.5642V7.53847C24 7.04884 23.8055 6.57926 23.4593 6.23304C23.1131 5.88682 22.6435 5.69232 22.1538 5.69232ZM1.84615 3.84616H7.92577L9.77192 5.69232H1.84615V3.84616ZM22.1538 20.4615H1.84615V7.53847H22.1538V20.4615Z"
        fill={props.color || "#404040"}
      />
      <rect x="14" y="12" width="16" height="16" rx="8" fill="#FF4C4C" />
      <path
        d="M19.1259 17.1259C19.1657 17.086 19.213 17.0543 19.265 17.0327C19.3171 17.0111 19.3729 17 19.4292 17C19.4856 17 19.5414 17.0111 19.5935 17.0327C19.6455 17.0543 19.6928 17.086 19.7326 17.1259L22.0001 19.3942L24.2676 17.1259C24.3075 17.086 24.3548 17.0544 24.4068 17.0329C24.4589 17.0113 24.5146 17.0002 24.571 17.0002C24.6273 17.0002 24.6831 17.0113 24.7352 17.0329C24.7872 17.0544 24.8345 17.086 24.8743 17.1259C24.9142 17.1657 24.9458 17.213 24.9673 17.2651C24.9889 17.3171 25 17.3729 25 17.4292C25 17.4856 24.9889 17.5414 24.9673 17.5934C24.9458 17.6455 24.9142 17.6928 24.8743 17.7326L22.606 20.0001L24.8743 22.2676C24.9142 22.3075 24.9458 22.3548 24.9673 22.4068C24.9889 22.4589 25 22.5146 25 22.571C25 22.6273 24.9889 22.6831 24.9673 22.7352C24.9458 22.7872 24.9142 22.8345 24.8743 22.8743C24.8345 22.9142 24.7872 22.9458 24.7352 22.9673C24.6831 22.9889 24.6273 23 24.571 23C24.5146 23 24.4589 22.9889 24.4068 22.9673C24.3548 22.9458 24.3075 22.9142 24.2676 22.8743L22.0001 20.606L19.7326 22.8743C19.6928 22.9142 19.6455 22.9458 19.5934 22.9673C19.5414 22.9889 19.4856 23 19.4292 23C19.3729 23 19.3171 22.9889 19.2651 22.9673C19.213 22.9458 19.1657 22.9142 19.1259 22.8743C19.086 22.8345 19.0544 22.7872 19.0329 22.7352C19.0113 22.6831 19.0002 22.6273 19.0002 22.571C19.0002 22.5146 19.0113 22.4589 19.0329 22.4068C19.0544 22.3548 19.086 22.3075 19.1259 22.2676L21.3942 20.0001L19.1259 17.7326C19.086 17.6928 19.0543 17.6455 19.0327 17.5935C19.0111 17.5414 19 17.4856 19 17.4292C19 17.3729 19.0111 17.3171 19.0327 17.265C19.0543 17.213 19.086 17.1657 19.1259 17.1259Z"
        fill="white"
      />
    </svg>
  );
};

export const SensorIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 24 24"
      opacity={0.9}
      fill="none"
    >
      <path
        d="M7.72297 7.71895C8.13607 8.13205 8.15968 8.7576 7.841 9.24151C7.34892 10.0051 7.08723 10.8943 7.08723 11.8027C7.08723 12.7112 7.34892 13.6004 7.841 14.364C8.15968 14.8479 8.12427 15.4852 7.71117 15.8865C7.20365 16.394 6.33024 16.3586 5.92894 15.7567C5.14307 14.5879 4.72389 13.2112 4.72505 11.8027C4.72505 10.3746 5.14995 9.05267 5.86993 7.9314C6.29483 7.29404 7.18004 7.17602 7.72297 7.71895ZM15.8905 15.8865C16.3981 16.394 17.2715 16.3586 17.6728 15.7567C18.4646 14.5879 18.8878 13.2086 18.8878 11.7968C18.8878 10.3851 18.4646 9.00578 17.6728 7.83698C17.2715 7.24683 16.3981 7.19962 15.8905 7.70714C15.4774 8.12024 15.4538 8.74579 15.7607 9.22971C16.2593 9.9926 16.5257 10.8837 16.5278 11.7951C16.5299 12.7064 16.2675 13.5988 15.7725 14.364C15.4538 14.8479 15.4893 15.4852 15.8905 15.8865ZM11.8068 9.44216C10.5084 9.44216 9.44619 10.5044 9.44619 11.8027C9.44619 13.101 10.5084 14.1633 11.8068 14.1633C13.1051 14.1633 14.1673 13.101 14.1673 11.8027C14.1673 10.5044 13.1051 9.44216 11.8068 9.44216ZM19.2662 19.2621C19.7619 19.7579 20.5881 19.7225 21.0366 19.1677C22.6418 17.1494 23.6096 14.5882 23.6096 11.8027C23.6096 9.01726 22.6418 6.45604 21.0366 4.43775C20.5999 3.88302 19.7737 3.84761 19.2662 4.34333C18.8413 4.76823 18.7941 5.42919 19.1717 5.90131C20.4701 7.5183 21.249 9.57199 21.249 11.8027C21.249 14.0335 20.4701 16.0872 19.1717 17.7042C18.7941 18.1645 18.8413 18.8372 19.2662 19.2621ZM4.34736 4.34333C3.85164 3.84761 3.02544 3.88302 2.57693 4.43775C0.97174 6.45604 0.00390625 9.01726 0.00390625 11.8027C0.00390625 14.5882 0.97174 17.1494 2.57693 19.1677C3.01363 19.7225 3.83983 19.7579 4.34736 19.2621C4.77226 18.8372 4.81947 18.1763 4.44178 17.7042C3.14347 16.0872 2.36448 14.0335 2.36448 11.8027C2.36448 9.57199 3.14347 7.5183 4.44178 5.90131C4.81947 5.441 4.77226 4.76823 4.34736 4.34333Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const LogisticIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.01392 0.7555C7.31379 0.588115 7.65385 0.5 8 0.5C8.34615 0.5 8.68621 0.588115 8.98608 0.7555C8.98645 0.755705 8.98681 0.75591 8.98718 0.756116L14.0128 3.53673C14.2608 3.67538 14.4741 3.86425 14.6385 4.08966C14.675 4.12327 14.7073 4.16246 14.7338 4.20684C14.757 4.24563 14.7744 4.2861 14.7863 4.32734C14.9263 4.59436 14.9997 4.88994 15 5.19033V10.7521C14.9996 11.0873 14.9082 11.4171 14.735 11.7074C14.5617 11.9976 14.3127 12.2386 14.0128 12.4062L14.0107 12.4074L8.98718 15.1868C8.98686 15.187 8.98655 15.1872 8.98623 15.1874C8.76803 15.3092 8.52854 15.389 8.28091 15.4235C8.19913 15.472 8.10294 15.5 8 15.5C7.89706 15.5 7.80087 15.472 7.71909 15.4235C7.47146 15.389 7.23197 15.3092 7.01377 15.1874C7.01346 15.1872 7.01314 15.187 7.01282 15.1868L1.98926 12.4074L1.98718 12.4062C1.68734 12.2386 1.43829 11.9976 1.26502 11.7074C1.09175 11.4171 1.00036 11.0879 1 10.7526L1 5.19086C1.00032 4.89048 1.07373 4.59436 1.21365 4.32735C1.2256 4.2861 1.24304 4.24563 1.26621 4.20684C1.29273 4.16246 1.32497 4.12327 1.36152 4.08966C1.52589 3.86425 1.73916 3.67538 1.98718 3.53673L1.98926 3.53557L7.01282 0.756116C7.01319 0.75591 7.01356 0.755705 7.01392 0.7555ZM2.07692 5.26323V10.7518C2.07713 10.9041 2.11867 11.0537 2.19739 11.1855C2.27598 11.3172 2.38889 11.4266 2.52481 11.5027C2.52508 11.5029 2.52453 11.5026 2.52481 11.5027L7.46154 14.2342V8.27915L2.07692 5.26323ZM8.53846 8.27915V14.2342L13.4744 11.5032C13.4746 11.503 13.4741 11.5034 13.4744 11.5032C13.6103 11.427 13.724 11.3172 13.8026 11.1855C13.8814 11.0536 13.9229 10.9039 13.9231 10.7516V5.26323L11.7759 6.46585L11.8189 8.43158C11.8252 8.71946 11.5893 8.95777 11.2919 8.96386C10.9946 8.96995 10.7485 8.74152 10.7422 8.45364L10.7118 7.06187L8.53846 8.27915ZM11.2341 5.56473L13.3577 4.37525L8.44872 1.65915C8.31229 1.58289 8.15753 1.54273 8 1.54273C7.84247 1.54273 7.68771 1.58288 7.55128 1.65915L7.54921 1.66031L5.88774 2.57957L11.2341 5.56473ZM4.80494 3.17866L10.1579 6.16751L8 7.37612L2.64225 4.37525L4.80494 3.17866Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const UserIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_324_1545)">
        <path
          d="M15.9093 15.0264C14.7389 12.9222 12.9352 11.4134 10.8303 10.6982C11.8715 10.0536 12.6804 9.07145 13.1329 7.90253C13.5854 6.73361 13.6563 5.44255 13.3349 4.22763C13.0135 3.01271 12.3174 1.9411 11.3537 1.17736C10.3899 0.413628 9.2117 0 8 0C6.7883 0 5.6101 0.413628 4.64633 1.17736C3.68257 1.9411 2.98653 3.01271 2.6651 4.22763C2.34368 5.44255 2.41464 6.73361 2.8671 7.90253C3.31955 9.07145 4.12848 10.0536 5.16965 10.6982C3.06476 11.4126 1.26112 12.9214 0.0907097 15.0264C0.0477887 15.0992 0.0193195 15.1802 0.00698187 15.2646C-0.00535579 15.349 -0.00131202 15.4351 0.0188746 15.5179C0.0390612 15.6006 0.0749818 15.6783 0.124517 15.7464C0.174052 15.8145 0.236198 15.8716 0.307289 15.9143C0.37838 15.957 0.456975 15.9844 0.538437 15.9951C0.6199 16.0057 0.702579 15.9992 0.781598 15.976C0.860616 15.9529 0.934373 15.9135 0.998516 15.8602C1.06266 15.8069 1.11589 15.7408 1.15507 15.6658C2.6029 13.0637 5.16197 11.5101 8 11.5101C10.838 11.5101 13.3971 13.0637 14.8449 15.6658C14.8841 15.7408 14.9373 15.8069 15.0015 15.8602C15.0656 15.9135 15.1394 15.9529 15.2184 15.976C15.2974 15.9992 15.3801 16.0057 15.4616 15.9951C15.543 15.9844 15.6216 15.957 15.6927 15.9143C15.7638 15.8716 15.8259 15.8145 15.8755 15.7464C15.925 15.6783 15.9609 15.6006 15.9811 15.5179C16.0013 15.4351 16.0054 15.349 15.993 15.2646C15.9807 15.1802 15.9522 15.0992 15.9093 15.0264ZM3.69646 5.75614C3.69646 4.87101 3.94886 4.00576 4.42174 3.2698C4.89462 2.53383 5.56674 1.96022 6.35311 1.6215C7.13948 1.28277 8.00478 1.19414 8.83958 1.36683C9.67438 1.53951 10.4412 1.96574 11.0431 2.59162C11.6449 3.2175 12.0548 4.01493 12.2208 4.88305C12.3869 5.75118 12.3017 6.65102 11.976 7.46877C11.6502 8.28653 11.0986 8.98547 10.3909 9.47723C9.6832 9.96898 8.85116 10.2315 8 10.2315C6.85901 10.2302 5.76509 9.75827 4.95829 8.91926C4.15148 8.08026 3.69768 6.94268 3.69646 5.75614Z"
          fill={props.color || "#404040"}
        />
      </g>
      <defs>
        <clipPath id="clip0_324_1545">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CornerLIcon = (props) => {
  return (
    <svg
      width={props.width || "6"}
      height={props.height || "6"}
      viewBox="0 0 6 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.42383 0.667969H0.278013V1.95442H5.42383V0.667969Z"
        fill="white"
      />
      <path
        d="M1.56447 5.81378V0.667969H0.278013V5.81378H1.56447Z"
        fill="white"
      />
    </svg>
  );
};

export const ProcedureUserIcon = (props) => {
  return (
    <>
      {!props.active ? (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.9206 20.1481C17.8965 18.307 16.3183 16.9867 14.4766 16.3609C15.3876 15.7969 16.0954 14.9375 16.4913 13.9147C16.8872 12.8919 16.9493 11.7622 16.668 10.6992C16.3868 9.63612 15.7778 8.69846 14.9345 8.03019C14.0912 7.36192 13.0602 7 12 7C10.9398 7 9.90884 7.36192 9.06554 8.03019C8.22225 8.69846 7.61321 9.63612 7.33196 10.6992C7.05072 11.7622 7.11281 12.8919 7.50871 13.9147C7.90461 14.9375 8.61242 15.7969 9.52345 16.3609C7.68167 16.986 6.10348 18.3063 5.07937 20.1481C5.04182 20.2118 5.0169 20.2827 5.00611 20.3565C4.99531 20.4304 4.99885 20.5057 5.01652 20.5781C5.03418 20.6505 5.06561 20.7185 5.10895 20.7781C5.1523 20.8377 5.20667 20.8876 5.26888 20.925C5.33108 20.9624 5.39985 20.9864 5.47113 20.9957C5.54241 21.0049 5.61476 20.9993 5.6839 20.979C5.75304 20.9587 5.81758 20.9243 5.8737 20.8777C5.92983 20.831 5.9764 20.7732 6.01068 20.7075C7.27754 18.4307 9.51672 17.0713 12 17.0713C14.4833 17.0713 16.7225 18.4307 17.9893 20.7075C18.0236 20.7732 18.0702 20.831 18.1263 20.8777C18.1824 20.9243 18.247 20.9587 18.3161 20.979C18.3852 20.9993 18.4576 21.0049 18.5289 20.9957C18.6001 20.9864 18.6689 20.9624 18.7311 20.925C18.7933 20.8876 18.8477 20.8377 18.891 20.7781C18.9344 20.7185 18.9658 20.6505 18.9835 20.5781C19.0011 20.5057 19.0047 20.4304 18.9939 20.3565C18.9831 20.2827 18.9582 20.2118 18.9206 20.1481ZM8.2344 12.0366C8.2344 11.2621 8.45525 10.505 8.86902 9.86107C9.28279 9.21711 9.8709 8.71519 10.559 8.41881C11.247 8.12242 12.0042 8.04488 12.7346 8.19597C13.4651 8.34707 14.1361 8.72002 14.6627 9.26767C15.1893 9.81532 15.5479 10.5131 15.6932 11.2727C15.8385 12.0323 15.764 12.8196 15.479 13.5352C15.1939 14.2507 14.7113 14.8623 14.0921 15.2926C13.4728 15.7229 12.7448 15.9525 12 15.9525C11.0016 15.9514 10.0445 15.5385 9.3385 14.8044C8.63255 14.0702 8.23547 13.0748 8.2344 12.0366Z"
            fill="white"
          />
        </svg>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2635_3463)">
            <path
              d="M18.9206 18.1481C17.8965 16.307 16.3183 14.9867 14.4766 14.3609C15.3876 13.7969 16.0954 12.9375 16.4913 11.9147C16.8872 10.8919 16.9493 9.76223 16.668 8.69918C16.3868 7.63612 15.7778 6.69846 14.9345 6.03019C14.0912 5.36192 13.0602 5 12 5C10.9398 5 9.90884 5.36192 9.06554 6.03019C8.22225 6.69846 7.61321 7.63612 7.33196 8.69918C7.05072 9.76223 7.11281 10.8919 7.50871 11.9147C7.90461 12.9375 8.61242 13.7969 9.52345 14.3609C7.68167 14.986 6.10348 16.3063 5.07937 18.1481C5.04182 18.2118 5.0169 18.2827 5.00611 18.3565C4.99531 18.4304 4.99885 18.5057 5.01652 18.5781C5.03418 18.6505 5.06561 18.7185 5.10895 18.7781C5.1523 18.8377 5.20667 18.8876 5.26888 18.925C5.33108 18.9624 5.39985 18.9864 5.47113 18.9957C5.54241 19.0049 5.61476 18.9993 5.6839 18.979C5.75304 18.9587 5.81758 18.9243 5.8737 18.8777C5.92983 18.831 5.9764 18.7732 6.01068 18.7075C7.27754 16.4307 9.51672 15.0713 12 15.0713C14.4833 15.0713 16.7225 16.4307 17.9893 18.7075C18.0236 18.7732 18.0702 18.831 18.1263 18.8777C18.1824 18.9243 18.247 18.9587 18.3161 18.979C18.3852 18.9993 18.4576 19.0049 18.5289 18.9957C18.6001 18.9864 18.6689 18.9624 18.7311 18.925C18.7933 18.8876 18.8477 18.8377 18.891 18.7781C18.9344 18.7185 18.9658 18.6505 18.9835 18.5781C19.0011 18.5057 19.0047 18.4304 18.9939 18.3565C18.9831 18.2827 18.9582 18.2118 18.9206 18.1481ZM8.2344 10.0366C8.2344 9.26213 8.45525 8.50504 8.86902 7.86107C9.28279 7.21711 9.8709 6.71519 10.559 6.41881C11.247 6.12242 12.0042 6.04488 12.7346 6.19597C13.4651 6.34707 14.1361 6.72002 14.6627 7.26767C15.1893 7.81532 15.5479 8.51306 15.6932 9.27267C15.8385 10.0323 15.764 10.8196 15.479 11.5352C15.1939 12.2507 14.7113 12.8623 14.0921 13.2926C13.4728 13.7229 12.7448 13.9525 12 13.9525C11.0016 13.9514 10.0445 13.5385 9.3385 12.8044C8.63255 12.0702 8.23547 11.0748 8.2344 10.0366Z"
              fill="white"
            />
            <path d="M4 24H0V20" stroke="white" />
            <path d="M20 0H24V4" stroke="white" />
          </g>
          <defs>
            <clipPath id="clip0_2635_3463">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export const AscendingOrderIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
    >
      <path
        d="M7 1.80027V9.19906C7 9.27888 6.96268 9.35542 6.89625 9.41186C6.82982 9.46829 6.73973 9.5 6.64578 9.5C6.55184 9.5 6.46174 9.46829 6.39532 9.41186C6.32889 9.35542 6.29157 9.27888 6.29157 9.19906V2.52733L3.6052 4.80962C3.53878 4.86613 3.44866 4.89791 3.35466 4.89796C3.26067 4.89802 3.17049 4.86635 3.10398 4.80992C3.03747 4.7535 3.00007 4.67693 3 4.59707C2.99993 4.51722 3.03721 4.44061 3.10363 4.3841L6.39571 1.58781C6.44524 1.54586 6.50829 1.5173 6.5769 1.50575C6.6455 1.49419 6.7166 1.50015 6.78123 1.52287C6.84586 1.54559 6.90112 1.58406 6.94006 1.63343C6.97899 1.68279 6.99985 1.74085 7 1.80027Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const DescendingOrderIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
    >
      <path
        d="M3 9.19973V1.80094C3 1.72112 3.03732 1.64458 3.10375 1.58814C3.17018 1.53171 3.26027 1.5 3.35422 1.5C3.44816 1.5 3.53826 1.53171 3.60468 1.58814C3.67111 1.64458 3.70843 1.72112 3.70843 1.80094V8.47267L6.3948 6.19038C6.46122 6.13387 6.55134 6.10209 6.64534 6.10204C6.73933 6.10198 6.82951 6.13365 6.89602 6.19008C6.96253 6.2465 6.99993 6.32307 7 6.40293C7.00007 6.48278 6.96279 6.55939 6.89637 6.6159L3.60429 9.41219C3.55476 9.45414 3.49171 9.4827 3.4231 9.49425C3.3545 9.50581 3.2834 9.49985 3.21877 9.47713C3.15414 9.45441 3.09888 9.41594 3.05994 9.36657C3.02101 9.31721 3.00015 9.25915 3 9.19973Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const DefaultSortIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
    >
      <path
        d="M4 1.80027V9.19906C4 9.27888 3.96268 9.35542 3.89625 9.41186C3.82982 9.46829 3.73973 9.5 3.64578 9.5C3.55184 9.5 3.46174 9.46829 3.39532 9.41186C3.32889 9.35542 3.29157 9.27888 3.29157 9.19906V2.52733L0.605198 4.80962C0.538779 4.86613 0.44866 4.89791 0.354664 4.89796C0.260667 4.89802 0.170494 4.86635 0.103982 4.80992C0.03747 4.7535 6.64112e-05 4.67693 -1.70839e-08 4.59707C-6.64454e-05 4.51722 0.0372099 4.44061 0.103628 4.3841L3.39571 1.58781C3.44524 1.54586 3.50829 1.5173 3.5769 1.50575C3.6455 1.49419 3.7166 1.50015 3.78123 1.52287C3.84586 1.54559 3.90112 1.58406 3.94006 1.63343C3.97899 1.68279 3.99985 1.74085 4 1.80027Z"
        fill={props.color || "#404040"}
      />
      <path
        d="M6 9.19973V1.80094C6 1.72112 6.03732 1.64458 6.10375 1.58814C6.17018 1.53171 6.26027 1.5 6.35422 1.5C6.44816 1.5 6.53826 1.53171 6.60468 1.58814C6.67111 1.64458 6.70843 1.72112 6.70843 1.80094V8.47267L9.3948 6.19038C9.46122 6.13387 9.55134 6.10209 9.64534 6.10204C9.73933 6.10198 9.82951 6.13365 9.89602 6.19008C9.96253 6.2465 9.99993 6.32307 10 6.40293C10.0001 6.48278 9.96279 6.55939 9.89637 6.6159L6.60429 9.41219C6.55476 9.45414 6.49171 9.4827 6.4231 9.49425C6.3545 9.50581 6.2834 9.49985 6.21877 9.47713C6.15414 9.45441 6.09888 9.41594 6.05994 9.36657C6.02101 9.31721 6.00015 9.25915 6 9.19973Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const SummaryIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 15V13.6H15V15H1Z" fill="white" />
      <path d="M5.6 4.2H7.2V12.2H5.6V4.2Z" fill="white" />
      <path d="M12 1H13.6V12.2H12V1Z" fill="white" />
      <path d="M2.4 7.4H4V12.2H2.4V7.4Z" fill="white" />
      <path d="M8.8 5.8H10.4V12.2H8.8V5.8Z" fill="white" />
    </svg>
  );
};

export const TableIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.7 5C9.58954 5 9.5 4.91046 9.5 4.8V0.2C9.5 0.0895429 9.58954 0 9.7 0H15.8C15.9105 0 16 0.089543 16 0.2V4.8C16 4.91046 15.9105 5 15.8 5H9.7ZM0.2 8C0.089543 8 0 7.91046 0 7.8V0.2C0 0.0895429 0.0895431 0 0.2 0H6.3C6.41046 0 6.5 0.0895431 6.5 0.2V7.8C6.5 7.91046 6.41046 8 6.3 8H0.2ZM9.7 16C9.58954 16 9.5 15.9105 9.5 15.8V8.2C9.5 8.08954 9.58954 8 9.7 8H15.8C15.9105 8 16 8.08954 16 8.2V15.8C16 15.9105 15.9105 16 15.8 16H9.7ZM0.2 16C0.089543 16 0 15.9105 0 15.8V11.2C0 11.0895 0.0895431 11 0.2 11H6.3C6.41046 11 6.5 11.0895 6.5 11.2V15.8C6.5 15.9105 6.41046 16 6.3 16H0.2ZM1 6.8C1 6.91046 1.08954 7 1.2 7H5.3C5.41046 7 5.5 6.91046 5.5 6.8V1.2C5.5 1.08954 5.41046 1 5.3 1H1.2C1.08954 1 1 1.08954 1 1.2V6.8ZM10.5 14.8C10.5 14.9105 10.5895 15 10.7 15H14.8C14.9105 15 15 14.9105 15 14.8V9.2C15 9.08954 14.9105 9 14.8 9H10.7C10.5895 9 10.5 9.08954 10.5 9.2V14.8ZM10.5 3.8C10.5 3.91046 10.5895 4 10.7 4H14.8C14.9105 4 15 3.91046 15 3.8V1.2C15 1.08954 14.9105 1 14.8 1H10.7C10.5895 1 10.5 1.08954 10.5 1.2V3.8ZM1 14.8C1 14.9105 1.08954 15 1.2 15H5.3C5.41046 15 5.5 14.9105 5.5 14.8V12.2C5.5 12.0895 5.41046 12 5.3 12H1.2C1.08954 12 1 12.0895 1 12.2V14.8Z"
        fill="white"
      />
    </svg>
  );
};

export const DashboardIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7 6C10.5895 6 10.5 5.91046 10.5 5.8V1.2C10.5 1.08954 10.5895 1 10.7 1H16.8C16.9105 1 17 1.08954 17 1.2V5.8C17 5.91046 16.9105 6 16.8 6H10.7ZM1.2 9C1.08954 9 1 8.91046 1 8.8V1.2C1 1.08954 1.08954 1 1.2 1H7.3C7.41046 1 7.5 1.08954 7.5 1.2V8.8C7.5 8.91046 7.41046 9 7.3 9H1.2ZM10.7 17C10.5895 17 10.5 16.9105 10.5 16.8V9.2C10.5 9.08954 10.5895 9 10.7 9H16.8C16.9105 9 17 9.08954 17 9.2V16.8C17 16.9105 16.9105 17 16.8 17H10.7ZM1.2 17C1.08954 17 1 16.9105 1 16.8V12.2C1 12.0895 1.08954 12 1.2 12H7.3C7.41046 12 7.5 12.0895 7.5 12.2V16.8C7.5 16.9105 7.41046 17 7.3 17H1.2ZM2 7.8C2 7.91046 2.08954 8 2.2 8H6.3C6.41046 8 6.5 7.91046 6.5 7.8V2.2C6.5 2.08954 6.41046 2 6.3 2H2.2C2.08954 2 2 2.08954 2 2.2V7.8ZM11.5 15.8C11.5 15.9105 11.5895 16 11.7 16H15.8C15.9105 16 16 15.9105 16 15.8V10.2C16 10.0895 15.9105 10 15.8 10H11.7C11.5895 10 11.5 10.0895 11.5 10.2V15.8ZM11.5 4.8C11.5 4.91046 11.5895 5 11.7 5H15.8C15.9105 5 16 4.91046 16 4.8V2.2C16 2.08954 15.9105 2 15.8 2H11.7C11.5895 2 11.5 2.08954 11.5 2.2V4.8ZM2 15.8C2 15.9105 2.08954 16 2.2 16H6.3C6.41046 16 6.5 15.9105 6.5 15.8V13.2C6.5 13.0895 6.41046 13 6.3 13H2.2C2.08954 13 2 13.0895 2 13.2V15.8Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const LogoutIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 17C1.22386 17 1 16.7761 1 16.5V1.5C1 1.22386 1.22386 1 1.5 1H8.52C8.79614 1 9.02 1.22386 9.02 1.5C9.02 1.77614 8.79614 2 8.52 2H2.5C2.22386 2 2 2.22386 2 2.5V15.5C2 15.7761 2.22386 16 2.5 16H8.52C8.79614 16 9.02 16.2239 9.02 16.5C9.02 16.7761 8.79614 17 8.52 17H1.5ZM13.8198 12.1802C13.6229 12.3771 13.3013 12.3735 13.1068 12.1742C12.9155 11.9783 12.9157 11.6633 13.1093 11.4697L15.079 9.5H6.692C6.41586 9.5 6.192 9.27614 6.192 9C6.192 8.72386 6.41586 8.5 6.692 8.5H15.079L13.1088 6.52984C12.915 6.33603 12.915 6.02063 13.1068 5.82479C13.3014 5.626 13.6226 5.62258 13.8193 5.8193L16.6464 8.64645C16.8417 8.84171 16.8417 9.15829 16.6464 9.35355L13.8198 12.1802Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const MapIcon = (props) => {
  return (
    <svg
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0002 17.7143L7.65021 11.5714C6.9382 10.7308 6.47967 9.70511 6.32804 8.61392C6.1764 7.52273 6.3379 6.41092 6.79372 5.40797C7.24954 4.40501 7.98092 3.5522 8.90268 2.94885C9.82445 2.3455 10.8987 2.01644 12.0002 2C13.5272 2.01509 14.9859 2.63471 16.057 3.72315C17.128 4.8116 17.724 6.28014 17.7145 7.80714C17.7151 9.13924 17.2616 10.4317 16.4288 11.4714L12.0002 17.7143ZM12.0002 3.42857C10.8515 3.44176 9.75504 3.91027 8.95151 4.73122C8.14797 5.55217 7.70307 6.65845 7.7145 7.80714C7.71928 8.85559 8.09648 9.86822 8.77878 10.6643L12.0002 15.2286L15.3074 10.5714C15.936 9.78675 16.2809 8.81257 16.2859 7.80714C16.2974 6.65845 15.8525 5.55217 15.0489 4.73122C14.2454 3.91027 13.1489 3.44176 12.0002 3.42857Z"
        fill={props.color || "white"}
      />
      <path
        d="M12 8.42857C12.789 8.42857 13.4286 7.78898 13.4286 7C13.4286 6.21102 12.789 5.57143 12 5.57143C11.211 5.57143 10.5714 6.21102 10.5714 7C10.5714 7.78898 11.211 8.42857 12 8.42857Z"
        fill={props.color || "white"}
      />
      <path
        d="M20.5714 9.14286H19.1429V10.5714H20.5714V20.5714H3.42857V10.5714H4.85714V9.14286H3.42857C3.04969 9.14286 2.68633 9.29337 2.41842 9.56128C2.15051 9.82919 2 10.1925 2 10.5714V20.5714C2 20.9503 2.15051 21.3137 2.41842 21.5816C2.68633 21.8495 3.04969 22 3.42857 22H20.5714C20.9503 22 21.3137 21.8495 21.5816 21.5816C21.8495 21.3137 22 20.9503 22 20.5714V10.5714C22 10.1925 21.8495 9.82919 21.5816 9.56128C21.3137 9.29337 20.9503 9.14286 20.5714 9.14286Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const SquareBoxNotSelected = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3.6093 3.6093C3.99876 3.21984 4.52676 3.00073 5.07752 3H18.9225C19.4732 3.00073 20.0012 3.21984 20.3907 3.6093L21.0978 2.90219L20.3907 3.6093C20.7803 3.99887 20.9994 4.52708 21 5.07802V18.922C20.9994 19.4729 20.7803 20.0011 20.3907 20.3907C20.0011 20.7803 19.4729 20.9994 18.922 21H5.07802C4.52708 20.9994 3.99887 20.7803 3.6093 20.3907L2.90219 21.0978L3.6093 20.3907C3.21984 20.0012 3.00073 19.4732 3 18.9225V5.07752C3.00073 4.52676 3.21984 3.99876 3.6093 3.6093Z"
        fill="none"
        stroke={props.color || "#404040"}
        strokeWidth="2"
      />
    </svg>
  );
};

export const SquareBoxSelected = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3.25575 3.25575C3.73889 2.7726 4.39394 2.50082 5.07721 2.5H18.9228C19.6061 2.50082 20.2611 2.7726 20.7443 3.25575C21.2275 3.73896 21.4993 4.39411 21.5 5.07747V18.9225C21.4993 19.6059 21.2275 20.261 20.7443 20.7443C20.261 21.2275 19.6059 21.4993 18.9225 21.5H5.07747C4.39411 21.4993 3.73895 21.2275 3.25575 20.7443C2.7726 20.2611 2.50082 19.6061 2.5 18.9228V5.07721C2.50082 4.39394 2.7726 3.73889 3.25575 3.25575Z"
        fill={props.color || "#0249D6"}
        stroke={props.color || "#0249D6"}
      />
      <path
        d="M10.9108 15.7755C10.7834 15.898 10.603 16 10.4438 16C10.2846 16 10.1042 15.8929 9.97154 15.7704L7.49079 13.3852C7.22291 13.1276 7.22291 12.6989 7.49079 12.4414V12.4414C7.74421 12.1977 8.14484 12.1977 8.39826 12.4414L10.4491 14.4133L16.6101 8.44675C16.8663 8.19867 17.2739 8.20137 17.5267 8.45283V8.45283C17.7866 8.71123 17.7836 9.13264 17.5201 9.38733L10.9108 15.7755Z"
        fill="white"
      />
    </svg>
  );
};

export const PhoneNumberIcon = (props) => {
  return (
    <svg
      width={props.width || "18"}
      height={props.height || "18"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.03718 1.68608C4.03566 0.639615 5.67982 0.825557 6.51585 2.00348L7.55125 3.45989C8.23222 4.41814 8.17151 5.75692 7.36337 6.60361L7.1681 6.80945C7.14606 6.89587 7.14381 6.98657 7.16154 7.07409C7.21323 7.42695 7.493 8.17418 8.66459 9.40226C9.83618 10.6303 10.55 10.9244 10.8896 10.9797C10.9751 10.9989 11.0637 10.9962 11.1481 10.972L11.4828 10.6208C12.2015 9.86842 13.3042 9.72745 14.1935 10.2368L15.7606 11.1363C17.1037 11.9043 17.4425 13.8277 16.3431 14.9805L15.1773 16.2017C14.8097 16.5866 14.3158 16.9074 13.7136 16.9671C12.2286 17.1133 8.76879 16.9264 5.13177 13.1151C1.7376 9.55707 1.08617 6.45399 1.0033 4.92494C0.962282 4.15177 1.30851 3.49794 1.74991 3.03611L3.03718 1.68608ZM5.53132 2.78098C5.11536 2.19548 4.34086 2.14878 3.90439 2.60628L2.61629 3.95544C2.34555 4.23912 2.21592 4.55219 2.23233 4.85143C2.29796 6.06654 2.82304 8.86606 5.9998 12.1957C9.33243 15.688 12.4099 15.7926 13.5995 15.675C13.8424 15.6517 14.0836 15.5185 14.3092 15.2824L15.4743 14.0603C15.9485 13.5639 15.8443 12.6593 15.1732 12.2753L13.6061 11.3767C13.1729 11.1294 12.6659 11.2107 12.3508 11.541L11.9775 11.9328L11.5427 11.4727C11.9775 11.9328 11.9767 11.9337 11.9759 11.9337L11.9751 11.9354L11.9726 11.938L11.9669 11.9432L11.9546 11.9553C11.9197 11.9889 11.8824 12.0195 11.843 12.047C11.7773 12.0928 11.6904 12.1438 11.5813 12.1862C11.3597 12.2736 11.066 12.3203 10.7034 12.2615C9.99207 12.1464 9.04938 11.6353 7.79656 10.3225C6.54457 9.00962 6.05559 8.02196 5.94565 7.27301C5.88904 6.89074 5.93416 6.58113 6.01785 6.34762C6.06425 6.21639 6.13016 6.09378 6.21311 5.98438L6.23936 5.95411L6.25085 5.94114L6.25577 5.93595L6.25824 5.93335L6.25988 5.93162L6.49616 5.68428C6.84731 5.31499 6.89654 4.70354 6.5659 4.23739L5.53132 2.78098Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const NoSelectionFallbackImage = (props) => {
  return (
    <svg
      width="99"
      height="110"
      viewBox="0 0 99 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.27539 42.6452C4.96414 70.2128 9.55185 84.7697 28.3994 108.545C28.6202 108.823 28.9848 108.968 29.3365 108.917C48.07 106.195 55.5792 104.743 71.7947 95.6735C79.0197 91.7643 84.8007 90.2915 96.9401 89.1691C97.7186 89.0971 98.1216 88.1916 97.6608 87.56C76.6458 58.7504 69.7478 38.5921 66.6192 2.18011C66.5665 1.56682 65.978 1.13369 65.3804 1.28121L22.6533 11.8278C23.6954 22.5109 25.386 28.2757 30.1494 38.2031C31.8698 40.8329 18.3815 44.4855 1.27539 42.6452Z"
        fill="#F2F2F2"
      />
      <path
        d="M22.6533 11.8278L1.27539 42.6452C18.3815 44.4855 31.8698 40.8329 30.1494 38.2031C25.386 28.2757 23.6954 22.5109 22.6533 11.8278Z"
        fill="#F2F2F2"
      />
      <path
        d="M1.27539 42.6452C4.96414 70.2128 9.55185 84.7697 28.3994 108.545C28.6202 108.823 28.9848 108.968 29.3365 108.917C48.07 106.195 55.5792 104.743 71.7947 95.6735C79.0197 91.7643 84.8007 90.2915 96.9401 89.1691C97.7186 89.0971 98.1216 88.1916 97.6608 87.56C76.6458 58.7504 69.7478 38.5921 66.6192 2.18011C66.5665 1.56682 65.978 1.13369 65.3804 1.28121L22.6533 11.8278M1.27539 42.6452L22.6533 11.8278M1.27539 42.6452C18.3815 44.4855 31.8698 40.8329 30.1494 38.2031C25.386 28.2757 23.6954 22.5109 22.6533 11.8278"
        stroke="#C2C2C2"
      />
      <rect
        opacity="0.2"
        x="26.8184"
        y="53.4146"
        width="36.6478"
        height="2.22108"
        rx="1"
        transform="rotate(-18 26.8184 53.4146)"
        fill="#404040"
      />
      <rect
        opacity="0.2"
        x="28.6562"
        y="57.8848"
        width="22.6553"
        height="2.22108"
        rx="1"
        transform="rotate(-18 28.6562 57.8848)"
        fill="#404040"
      />
      <rect
        opacity="0.2"
        x="14.6016"
        y="57.4062"
        width="8.88432"
        height="8.88432"
        rx="1"
        transform="rotate(-20.4237 14.6016 57.4062)"
        stroke="black"
      />
      <rect
        opacity="0.2"
        x="34.0371"
        y="72.2939"
        width="36.6478"
        height="2.22108"
        rx="1"
        transform="rotate(-18 34.0371 72.2939)"
        fill="#404040"
      />
      <rect
        opacity="0.2"
        x="35.875"
        y="76.7642"
        width="22.6553"
        height="2.22108"
        rx="1"
        transform="rotate(-18 35.875 76.7642)"
        fill="#404040"
      />
      <rect
        opacity="0.2"
        x="21.8203"
        y="76.2856"
        width="8.88432"
        height="8.88432"
        rx="1"
        transform="rotate(-20.4237 21.8203 76.2856)"
        fill="#404040"
      />
    </svg>
  );
};

export const ComplaintsIcon = (props) => {
  return (
    <svg
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 15H13V17H11V15ZM11 7H13V13H11V7ZM12 2C6.47 2 2 6.5 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const PresetIcon = (props) => {
  return (
    <svg
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8 2H5.15789H2.2C2.08954 2 2 2.08954 2 2.2V21.8C2 21.9105 2.08954 22 2.2 22H21.8C21.9105 22 22 21.9105 22 21.8V2.2C22 2.08954 21.9105 2 21.8 2Z"
        stroke="white"
        strokeWidth="1.8"
      />
      <path
        d="M8 8C8 9.10457 7.10457 10 6 10C4.89543 10 4 9.10457 4 8C4 6.89543 4.89543 6 6 6C7.10457 6 8 6.89543 8 8Z"
        fill={props.color || "white"}
      />
      <path
        d="M10 7.75C10 7.33579 10.2239 7 10.5 7H19.5C19.7761 7 20 7.33579 20 7.75C20 8.16421 19.7761 8.5 19.5 8.5H10.5C10.2239 8.5 10 8.16421 10 7.75Z"
        fill={props.color || "white"}
      />
      <path
        d="M8 16C8 17.1046 7.10457 18 6 18C4.89543 18 4 17.1046 4 16C4 14.8954 4.89543 14 6 14C7.10457 14 8 14.8954 8 16Z"
        fill={props.color || "white"}
      />
      <path
        d="M10 15.75C10 15.3358 10.2239 15 10.5 15H19.5C19.7761 15 20 15.3358 20 15.75C20 16.1642 19.7761 16.5 19.5 16.5H10.5C10.2239 16.5 10 16.1642 10 15.75Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const DragIcon = (props) => {
  return (
    <svg
      width={props?.width || "16"}
      height={props?.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="5" width="16" height="1" fill="white" />
      <rect y="10" width="16" height="1" fill="white" />
    </svg>
  );
};

export const NoImageProvidedIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0.707L13.293 0L0 13.293L0.707 14L1.707 13H12C12.2651 12.9996 12.5192 12.8941 12.7067 12.7067C12.8941 12.5192 12.9996 12.2651 13 12V1.707L14 0.707ZM12 12H2.707L6.6035 8.1035L7.793 9.293C7.98053 9.48047 8.23484 9.58579 8.5 9.58579C8.76516 9.58579 9.01947 9.48047 9.207 9.293L10 8.5L12 10.4985V12ZM12 9.084L10.707 7.791C10.5195 7.60353 10.2652 7.49821 10 7.49821C9.73484 7.49821 9.48053 7.60353 9.293 7.791L8.5 8.584L7.3115 7.3955L12 2.707V9.084ZM2 10V8.5L4.5 6.0015L5.1865 6.6885L5.8945 5.9805L5.207 5.293C5.01947 5.10553 4.76516 5.00021 4.5 5.00021C4.23484 5.00021 3.98053 5.10553 3.793 5.293L2 7.086V2H10V1H2C1.73486 1.00026 1.48066 1.10571 1.29319 1.29319C1.10571 1.48066 1.00026 1.73486 1 2V10H2Z"
        fill="white"
      />
    </svg>
  );
};

export const TickRoundIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="8" fill={props.color || "#00892F"} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9952 6.03526L6.44132 10.7957L3.95117 7.47554L4.55117 7.02554L6.56102 9.70534L11.5071 5.46582L11.9952 6.03526Z"
        fill="white"
      />
    </svg>
  );
};

export const ErrorRoundIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="8" fill={props.color || "#C51515"} />
      <path
        d="M8.5 12.5455C8.5 12.7965 8.27614 13 8 13C7.72386 13 7.5 12.7965 7.5 12.5455C7.5 12.2944 7.72386 12.0909 8 12.0909C8.27614 12.0909 8.5 12.2944 8.5 12.5455Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 10.2727V3H8.5V10.2727H7.5Z"
        fill="white"
      />
    </svg>
  );
};

export const OfflineCameraIcon = (props) => {
  return (
    <svg
      width={props.width || "11"}
      height={props.height || "8"}
      viewBox="0 0 11 8"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.55209 0.791016H3.05208C2.66531 0.791016 2.29438 0.944665 2.02089 1.21816C1.7474 1.49166 1.59375 1.86261 1.59375 2.24939V5.16614C1.59375 5.55293 1.7474 5.92387 2.02089 6.19737C2.29438 6.47087 2.66531 6.62452 3.05208 6.62452H6.55209C6.93886 6.62452 7.30979 6.47087 7.58329 6.19737C7.85678 5.92387 8.01042 5.55293 8.01042 5.16614V2.24939C8.01042 1.86261 7.85678 1.49166 7.58329 1.21816C7.30979 0.944665 6.93886 0.791016 6.55209 0.791016ZM2.17708 2.24939C2.17708 2.01732 2.26927 1.79475 2.43337 1.63065C2.59746 1.46656 2.82002 1.37437 3.05208 1.37437H6.55209C6.78415 1.37437 7.00671 1.46656 7.17081 1.63065C7.3349 1.79475 7.42709 2.01732 7.42709 2.24939V5.16614C7.42709 5.39821 7.3349 5.62078 7.17081 5.78488C7.00671 5.94898 6.78415 6.04117 6.55209 6.04117H3.05208C2.82002 6.04117 2.59746 5.94898 2.43337 5.78488C2.26927 5.62078 2.17708 5.39821 2.17708 5.16614V2.24939Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.85202 1.42267L7.62077 2.58453C7.56893 2.61144 7.5262 2.64819 7.49639 2.69151C7.46659 2.73484 7.45063 2.7834 7.44995 2.83286L7.42972 4.39959C7.42895 4.45012 7.44414 4.49997 7.47387 4.54454C7.5036 4.58911 7.54692 4.62694 7.59979 4.65452L9.85052 5.82537C9.90706 5.85487 9.97249 5.87159 10.0399 5.87378C10.1073 5.87596 10.1743 5.86352 10.2336 5.83778C10.2929 5.81204 10.3425 5.77394 10.377 5.72752C10.4115 5.6811 10.4297 5.62807 10.4297 5.57405V1.6746C10.4298 1.62052 10.4117 1.56742 10.3773 1.52092C10.3428 1.47441 10.2933 1.43623 10.2339 1.41041C10.1746 1.38459 10.1076 1.3721 10.0401 1.37426C9.97262 1.37642 9.90711 1.39315 9.85052 1.42267M9.68119 5.02161L8.18196 4.24124L8.19769 2.99961L9.68119 2.22764V5.02161Z"
        fill="white"
      />
      <path
        d="M1.0356 0.390198C0.992756 0.347291 0.968708 0.289119 0.96875 0.228481C0.968792 0.167842 0.99292 0.109704 1.03583 0.0668554C1.07873 0.024007 1.1369 -4.16214e-05 1.19754 5.40765e-08C1.25818 4.17296e-05 1.31631 0.0241702 1.35916 0.0670776L8.90183 7.60996C8.94468 7.65281 8.96875 7.71092 8.96875 7.77152C8.96875 7.83212 8.94468 7.89023 8.90183 7.93308C8.85898 7.97593 8.80087 8 8.74028 8C8.67968 8 8.62157 7.97593 8.57872 7.93308L1.0356 0.390198Z"
        fill="white"
      />
    </svg>
  );
};

export const FieldViewIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.9897 3.74061H4.30793C3.99353 3.74061 3.73865 3.99548 3.73865 4.30988V6.99165C3.73865 7.30606 3.99353 7.56093 4.30793 7.56093H6.9897C7.3041 7.56093 7.55898 7.30606 7.55898 6.99165V4.30988C7.55898 3.99548 7.3041 3.74061 6.9897 3.74061ZM15.6891 3.74061H13.0073C12.6929 3.74061 12.438 3.99548 12.438 4.30988V6.99165C12.438 7.30606 12.6929 7.56093 13.0073 7.56093H15.6891C16.0035 7.56093 16.2584 7.30606 16.2584 6.99165V4.30988C16.2584 3.99548 16.0035 3.74061 15.6891 3.74061ZM6.9897 12.44H4.30793C3.99353 12.44 3.73865 12.6949 3.73865 13.0093V15.691C3.73865 16.0054 3.99353 16.2603 4.30793 16.2603H6.9897C7.3041 16.2603 7.55898 16.0054 7.55898 15.691V13.0093C7.55898 12.6949 7.3041 12.44 6.9897 12.44ZM15.6891 12.44H13.0073C12.6929 12.44 12.438 12.6949 12.438 13.0093V15.691C12.438 16.0054 12.6929 16.2603 13.0073 16.2603H15.6891C16.0035 16.2603 16.2584 16.0054 16.2584 15.691V13.0093C16.2584 12.6949 16.0035 12.44 15.6891 12.44ZM4.30793 2.2168C3.15195 2.2168 2.21484 3.1539 2.21484 4.30988V6.99165C2.21484 8.14763 3.15195 9.08474 4.30793 9.08474H6.9897C8.14568 9.08474 9.08279 8.14763 9.08279 6.99165V4.30988C9.08279 3.1539 8.14568 2.2168 6.9897 2.2168H4.30793ZM13.0073 2.2168C11.8513 2.2168 10.9142 3.1539 10.9142 4.30988V6.99165C10.9142 8.14763 11.8513 9.08474 13.0073 9.08474H15.6891C16.8451 9.08474 17.7822 8.14763 17.7822 6.99165V4.30988C17.7822 3.1539 16.8451 2.2168 15.6891 2.2168H13.0073ZM2.21484 13.0093C2.21484 11.8533 3.15195 10.9162 4.30793 10.9162H6.9897C8.14568 10.9162 9.08279 11.8533 9.08279 13.0093V15.691C9.08279 16.847 8.14568 17.7841 6.9897 17.7841H4.30793C3.15195 17.7841 2.21484 16.847 2.21484 15.691V13.0093ZM13.0073 10.9162C11.8513 10.9162 10.9142 11.8533 10.9142 13.0093V15.691C10.9142 16.847 11.8513 17.7841 13.0073 17.7841H15.6891C16.8451 17.7841 17.7822 16.847 17.7822 15.691V13.0093C17.7822 11.8533 16.8451 10.9162 15.6891 10.9162H13.0073Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const LocationsIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0069 18.1707L5.48329 11.7826C4.74285 10.9084 4.26602 9.84179 4.10833 8.70704C3.95064 7.5723 4.11859 6.4161 4.5926 5.37311C5.06662 4.33012 5.8272 3.44327 6.78576 2.81583C7.74432 2.18839 8.86141 1.8462 10.0069 1.8291C11.5949 1.84479 13.1118 2.48915 14.2256 3.62104C15.3394 4.75293 15.9592 6.2801 15.9493 7.86806C15.9499 9.25333 15.4783 10.5974 14.6123 11.6786L10.0069 18.1707ZM10.0069 3.3147C8.81241 3.32842 7.67214 3.81563 6.83653 4.66935C6.00091 5.52307 5.53825 6.67351 5.55014 7.86806C5.55511 8.95836 5.94738 10.0114 6.65691 10.8393L10.0069 15.5857L13.4461 10.7427C14.0998 9.92669 14.4585 8.91362 14.4637 7.86806C14.4756 6.67351 14.013 5.52307 13.1773 4.66935C12.3417 3.81563 11.2015 3.32842 10.0069 3.3147Z"
        fill={props.color || "white"}
      />
      <path
        d="M10.0067 8.51429C10.8272 8.51429 11.4923 7.84917 11.4923 7.0287C11.4923 6.20822 10.8272 5.5431 10.0067 5.5431C9.18624 5.5431 8.52112 6.20822 8.52112 7.0287C8.52112 7.84917 9.18624 8.51429 10.0067 8.51429Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const WorkforceIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1539 17.245C16.9471 15.0754 15.0874 13.5197 12.917 12.7822C13.9906 12.1176 14.8246 11.1049 15.2912 9.89966C15.7577 8.6944 15.8309 7.36321 15.4994 6.11052C15.168 4.85783 14.4503 3.7529 13.4566 2.96543C12.4629 2.17795 11.2481 1.75146 9.9987 1.75146C8.74933 1.75146 7.5345 2.17795 6.54077 2.96543C5.54705 3.7529 4.82937 4.85783 4.49795 6.11052C4.16654 7.36321 4.23971 8.6944 4.70623 9.89966C5.17275 11.1049 6.00682 12.1176 7.08036 12.7822C4.91004 13.5189 3.05032 15.0746 1.84353 17.245C1.79927 17.3201 1.76992 17.4036 1.7572 17.4906C1.74448 17.5776 1.74865 17.6664 1.76946 17.7517C1.79028 17.8371 1.82731 17.9172 1.87839 17.9874C1.92946 18.0576 1.99354 18.1164 2.06684 18.1605C2.14014 18.2045 2.22118 18.2328 2.30518 18.2438C2.38917 18.2547 2.47442 18.248 2.5559 18.2241C2.63737 18.2003 2.71342 18.1596 2.77956 18.1047C2.84569 18.0498 2.90058 17.9816 2.94098 17.9042C4.43382 15.2213 7.07244 13.6194 9.9987 13.6194C12.925 13.6194 15.5636 15.2213 17.0564 17.9042C17.0968 17.9816 17.1517 18.0498 17.2178 18.1047C17.284 18.1596 17.36 18.2003 17.4415 18.2241C17.523 18.248 17.6082 18.2547 17.6922 18.2438C17.7762 18.2328 17.8573 18.2045 17.9306 18.1605C18.0039 18.1164 18.0679 18.0576 18.119 17.9874C18.1701 17.9172 18.2071 17.8371 18.2279 17.7517C18.2487 17.6664 18.2529 17.5776 18.2402 17.4906C18.2275 17.4036 18.1981 17.3201 18.1539 17.245ZM5.56137 7.68655C5.56137 6.7739 5.82162 5.88175 6.3092 5.12291C6.79678 4.36407 7.48979 3.77262 8.30061 3.42337C9.11142 3.07411 10.0036 2.98273 10.8644 3.16078C11.7251 3.33883 12.5158 3.77831 13.1364 4.42365C13.7569 5.06899 14.1795 5.89121 14.3508 6.78632C14.522 7.68143 14.4341 8.60924 14.0983 9.45242C13.7624 10.2956 13.1937 11.0163 12.4639 11.5233C11.7342 12.0304 10.8763 12.301 9.9987 12.301C8.82223 12.2997 7.69431 11.8131 6.86243 10.948C6.03054 10.0829 5.56263 8.90997 5.56137 7.68655Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const DevicesIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0002 3.00098V4.99994H11.4002V3.00098H13.0002V4.99994C14.1042 5.00057 14.999 5.89576 14.999 6.99994V7.40111H16.9985C16.9985 9.00111 16.9985 7.40111 16.9985 9.00111H14.999V11.4011H16.9985V13.0011H14.999C14.9984 14.1051 14.1032 14.9999 12.999 14.9999H12.5979V16.9989C10.9979 16.9989 12.5979 16.9989 10.9979 16.9989V14.9999H8.59785V16.9989H6.99785V14.9999C5.89382 14.9993 4.99902 14.1041 4.99902 12.9999V12.5988H3C3.00076 10.9988 3 12.5988 3 10.9988H4.99902V8.59877L3 8.59877V6.99877H4.99902C4.99966 5.89474 5.89484 4.99994 6.99902 4.99994H7.4002V3.00098C9.0002 3.00098 7.4002 3.00098 9.0002 3.00098ZM6.99902 6.59994H12.999C13.2199 6.59994 13.399 6.77903 13.399 6.99994V12.9999C13.399 13.2209 13.2199 13.3999 12.999 13.3999H6.99902C6.77811 13.3999 6.59902 13.2209 6.59902 12.9999V6.99994C6.59902 6.77903 6.77811 6.59994 6.99902 6.59994Z"
        fill="#CFCFCF"
      />
    </svg>
  );
};

export const CallsIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.02279 2.66779C5.02378 1.61869 6.6721 1.8051 7.51024 2.98599L8.54825 4.44607C9.23093 5.40674 9.17007 6.74891 8.35989 7.59773L8.16413 7.80408C8.14203 7.89072 8.13978 7.98166 8.15755 8.06939C8.20937 8.42314 8.48985 9.17226 9.6644 10.4034C10.8389 11.6346 11.5545 11.9294 11.895 11.9849C11.9808 12.0041 12.0696 12.0014 12.1541 11.9771L12.4897 11.6251C13.2102 10.8708 14.3157 10.7294 15.2073 11.2401L16.7783 12.1418C18.1248 12.9118 18.4644 14.84 17.3623 15.9958L16.1935 17.22C15.825 17.6059 15.3299 17.9275 14.7261 17.9874C13.2374 18.1339 9.76886 17.9466 6.12266 14.1256C2.71993 10.5586 2.06685 7.44773 1.98378 5.91482C1.94266 5.1397 2.28976 4.48422 2.73227 4.02123L4.02279 2.66779ZM6.52322 3.76545C6.10621 3.17847 5.32976 3.13165 4.89218 3.59031L3.60084 4.94288C3.32941 5.22727 3.19945 5.54113 3.2159 5.84113C3.2817 7.0593 3.80811 9.86588 6.99288 13.2039C10.3339 16.705 13.4192 16.8099 14.6118 16.692C14.8553 16.6686 15.0971 16.5351 15.3233 16.2984L16.4912 15.0733C16.9667 14.5756 16.8622 13.6687 16.1894 13.2837L14.6184 12.3829C14.1841 12.1349 13.6758 12.2164 13.3599 12.5476L12.9857 12.9404L12.5498 12.4791C12.9857 12.9404 12.9849 12.9412 12.9841 12.9412L12.9832 12.943L12.9808 12.9456L12.975 12.9508L12.9627 12.9629C12.9277 12.9966 12.8903 13.0273 12.8508 13.0548C12.785 13.1008 12.6978 13.1519 12.5884 13.1944C12.3663 13.282 12.0719 13.3288 11.7083 13.2698C10.9952 13.1545 10.0502 12.6421 8.79418 11.326C7.53903 10.0098 7.04881 9.01966 6.93859 8.26881C6.88184 7.88558 6.92708 7.57519 7.01097 7.34109C7.0575 7.20953 7.12357 7.08661 7.20673 6.97694L7.23305 6.94659L7.24457 6.93358L7.2495 6.92838L7.25197 6.92578L7.25361 6.92405L7.4905 6.67608C7.84253 6.30585 7.89188 5.69286 7.56041 5.22553L6.52322 3.76545Z"
        fill="#CFCFCF"
      />
    </svg>
  );
};

export const ProceduresIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8 7.89215C12.0685 7.54206 13 6.37981 13 5C13 3.34315 11.6569 2 10 2C8.34315 2 7 3.34315 7 5C7 6.37981 7.93153 7.54206 9.2 7.89215V9.2H6C5.00589 9.2 4.2 10.0059 4.2 11V12.1078C2.93153 12.4579 2 13.6202 2 15C2 16.6569 3.34315 18 5 18C6.65685 18 8 16.6569 8 15C8 13.6202 7.06847 12.4579 5.8 12.1078V11C5.8 10.8895 5.88954 10.8 6 10.8H14C14.1105 10.8 14.2 10.8895 14.2 11V12.1078C12.9315 12.4579 12 13.6202 12 15C12 16.6569 13.3431 18 15 18C16.6569 18 18 16.6569 18 15C18 13.6202 17.0685 12.4579 15.8 12.1078V11C15.8 10.0059 14.9941 9.2 14 9.2H10.8V7.89215ZM11.4 5C11.4 5.7732 10.7732 6.4 10 6.4C9.2268 6.4 8.6 5.7732 8.6 5C8.6 4.2268 9.2268 3.6 10 3.6C10.7732 3.6 11.4 4.2268 11.4 5ZM16.4 15C16.4 15.7732 15.7732 16.4 15 16.4C14.2268 16.4 13.6 15.7732 13.6 15C13.6 14.2268 14.2268 13.6 15 13.6C15.7732 13.6 16.4 14.2268 16.4 15ZM5 16.4C5.7732 16.4 6.4 15.7732 6.4 15C6.4 14.2268 5.7732 13.6 5 13.6C4.2268 13.6 3.6 14.2268 3.6 15C3.6 15.7732 4.2268 16.4 5 16.4Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const ReportsIcon = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.2181 4.16699H6.55143C6.1094 4.16699 5.68548 4.34259 5.37292 4.65515C5.06036 4.96771 4.88477 5.39163 4.88477 5.83366V15.8337C4.88477 16.2757 5.06036 16.6996 5.37292 17.0122C5.68548 17.3247 6.1094 17.5003 6.55143 17.5003H14.8848C15.3268 17.5003 15.7507 17.3247 16.0633 17.0122C16.3758 16.6996 16.5514 16.2757 16.5514 15.8337V5.83366C16.5514 5.39163 16.3758 4.96771 16.0633 4.65515C15.7507 4.34259 15.3268 4.16699 14.8848 4.16699H13.2181"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.21875 4.16667C8.21875 3.72464 8.39435 3.30072 8.70691 2.98816C9.01947 2.67559 9.44339 2.5 9.88542 2.5H11.5521C11.9941 2.5 12.418 2.67559 12.7306 2.98816C13.0432 3.30072 13.2187 3.72464 13.2187 4.16667C13.2187 4.60869 13.0432 5.03262 12.7306 5.34518C12.418 5.65774 11.9941 5.83333 11.5521 5.83333H9.88542C9.44339 5.83333 9.01947 5.65774 8.70691 5.34518C8.39435 5.03262 8.21875 4.60869 8.21875 4.16667Z"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.21875 14.1663V10.833"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7188 14.1663V13.333"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2188 14.1667V12.5"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7188 14.1663V13.333"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OptionsIcon = (props) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.86558 2.8001C9.86558 3.46284 9.32832 4.0001 8.66558 4.0001C8.00283 4.0001 7.46558 3.46284 7.46558 2.8001C7.46558 2.13736 8.00283 1.6001 8.66558 1.6001C9.32832 1.6001 9.86558 2.13736 9.86558 2.8001Z"
        fill={props.color || "white"}
      />
      <path
        d="M9.86558 8.0001C9.86558 8.66284 9.32832 9.2001 8.66558 9.2001C8.00283 9.2001 7.46558 8.66284 7.46558 8.0001C7.46558 7.33736 8.00283 6.8001 8.66558 6.8001C9.32832 6.8001 9.86558 7.33736 9.86558 8.0001Z"
        fill={props.color || "white"}
      />
      <path
        d="M8.66558 14.4001C9.32832 14.4001 9.86558 13.8628 9.86558 13.2001C9.86558 12.5374 9.32832 12.0001 8.66558 12.0001C8.00283 12.0001 7.46558 12.5374 7.46558 13.2001C7.46558 13.8628 8.00283 14.4001 8.66558 14.4001Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const PencilIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.2002 12.8H5.6002L11.9002 6.49996C12.2185 6.1817 12.3973 5.75005 12.3973 5.29996C12.3973 4.84987 12.2185 4.41822 11.9002 4.09996C11.5819 3.7817 11.1503 3.60291 10.7002 3.60291C10.2501 3.60291 9.81846 3.7817 9.5002 4.09996L3.2002 10.4V12.8Z"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.8999 4.69995L11.2999 7.09995"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AtIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.375 9.99995C13.375 10.8951 13.0194 11.7535 12.3865 12.3864C11.7536 13.0194 10.8951 13.375 10 13.375C9.1049 13.375 8.24645 13.0194 7.61352 12.3864C6.98058 11.7535 6.625 10.8951 6.625 9.99995C6.625 9.10485 6.98058 8.2464 7.61352 7.61347C8.24645 6.98053 9.1049 6.62495 10 6.62495C10.8951 6.62495 11.7536 6.98053 12.3865 7.61347C13.0194 8.2464 13.375 9.10485 13.375 9.99995ZM13.375 9.99995C13.375 11.2427 14.1303 12.25 15.0625 12.25C15.9948 12.25 16.75 11.2427 16.75 9.99995C16.75 8.4383 16.2085 6.92497 15.2178 5.71781C14.2271 4.51065 12.8485 3.68435 11.3168 3.3797C9.78516 3.07505 8.19527 3.3109 6.81803 4.04707C5.44078 4.78323 4.3614 5.97416 3.7638 7.41694C3.16619 8.85972 3.08734 10.4651 3.54067 11.9595C3.994 13.4539 4.95147 14.7449 6.24994 15.6125C7.54841 16.4801 9.10753 16.8706 10.6617 16.7175C12.2158 16.5644 13.6688 15.8772 14.773 14.773M13.375 9.99995V7.18745"
        stroke="#CFCFCF"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LockIcon = (props) => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.375 7.875V5.0625C10.375 4.16739 10.0194 3.30895 9.38649 2.67601C8.75355 2.04308 7.89511 1.6875 7 1.6875C6.10489 1.6875 5.24645 2.04308 4.61351 2.67601C3.98058 3.30895 3.625 4.16739 3.625 5.0625V7.875M3.0625 16.3125H10.9375C11.3851 16.3125 11.8143 16.1347 12.1307 15.8182C12.4472 15.5018 12.625 15.0726 12.625 14.625V9.5625C12.625 9.11495 12.4472 8.68573 12.1307 8.36926C11.8143 8.05279 11.3851 7.875 10.9375 7.875H3.0625C2.61495 7.875 2.18573 8.05279 1.86926 8.36926C1.55279 8.68573 1.375 9.11495 1.375 9.5625V14.625C1.375 15.0726 1.55279 15.5018 1.86926 15.8182C2.18573 16.1347 2.61495 16.3125 3.0625 16.3125Z"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ThemeIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2956_22677)">
        <path
          d="M10 17.5C8.01088 17.5 6.10322 16.7098 4.6967 15.3033C3.29018 13.8968 2.5 11.9891 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C14.1417 2.5 17.5 5.485 17.5 9.16667C17.5 10.05 17.105 10.8983 16.4017 11.5233C15.6983 12.1483 14.7442 12.5 13.75 12.5H11.6667C11.2949 12.494 10.9318 12.6125 10.6351 12.8367C10.3384 13.0608 10.1252 13.3777 10.0294 13.737C9.93362 14.0963 9.9607 14.4773 10.1064 14.8194C10.252 15.1615 10.5079 15.4451 10.8333 15.625C10.9997 15.7785 11.1138 15.9803 11.1596 16.2021C11.2054 16.4238 11.1806 16.6543 11.0886 16.8612C10.9967 17.068 10.8422 17.2409 10.647 17.3555C10.4517 17.4701 10.2255 17.5206 10 17.5Z"
          stroke={props.color || "white"}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 8.75033C6.25 8.97134 6.3378 9.1833 6.49408 9.33958C6.65036 9.49586 6.86232 9.58366 7.08333 9.58366C7.30435 9.58366 7.51631 9.49586 7.67259 9.33958C7.82887 9.1833 7.91667 8.97134 7.91667 8.75033C7.91667 8.52931 7.82887 8.31735 7.67259 8.16107C7.51631 8.00479 7.30435 7.91699 7.08333 7.91699C6.86232 7.91699 6.65036 8.00479 6.49408 8.16107C6.3378 8.31735 6.25 8.52931 6.25 8.75033Z"
          stroke={props.color || "white"}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5835 6.25033C9.5835 6.47134 9.67129 6.6833 9.82757 6.83958C9.98385 6.99586 10.1958 7.08366 10.4168 7.08366C10.6378 7.08366 10.8498 6.99586 11.0061 6.83958C11.1624 6.6833 11.2502 6.47134 11.2502 6.25033C11.2502 6.02931 11.1624 5.81735 11.0061 5.66107C10.8498 5.50479 10.6378 5.41699 10.4168 5.41699C10.1958 5.41699 9.98385 5.50479 9.82757 5.66107C9.67129 5.81735 9.5835 6.02931 9.5835 6.25033Z"
          stroke={props.color || "white"}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9165 8.75033C12.9165 8.97134 13.0043 9.1833 13.1606 9.33958C13.3169 9.49586 13.5288 9.58366 13.7498 9.58366C13.9709 9.58366 14.1828 9.49586 14.3391 9.33958C14.4954 9.1833 14.5832 8.97134 14.5832 8.75033C14.5832 8.52931 14.4954 8.31735 14.3391 8.16107C14.1828 8.00479 13.9709 7.91699 13.7498 7.91699C13.5288 7.91699 13.3169 8.00479 13.1606 8.16107C13.0043 8.31735 12.9165 8.52931 12.9165 8.75033Z"
          stroke={props.color || "white"}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2956_22677">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BellIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0194 16.4713C11.7873 16.7893 11.4835 17.048 11.1326 17.2263C10.7816 17.4047 10.3936 17.4976 9.99991 17.4976C9.60626 17.4976 9.21818 17.4047 8.86725 17.2263C8.51632 17.048 8.21247 16.7893 7.98043 16.4713M12.3807 14.235C13.9334 14.0512 15.459 13.6847 16.9257 13.1433C15.6836 11.7673 14.9972 9.97875 14.9999 8.125C14.9999 6.5658 14.6843 5.11336 13.5354 3.96447C12.5978 3.02678 11.326 2.5 9.99991 2.5C8.67383 2.5 7.40206 3.02678 6.46438 3.96447C5.31548 5.11336 4.99991 6.5658 4.99991 8.125C5.00242 9.97886 4.31573 11.7675 3.07324 13.1433C4.51741 13.6767 6.03991 14.0475 7.61908 14.235C9.20075 14.4226 10.7991 14.4226 12.3807 14.235Z"
        stroke="#CFCFCF"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LanguagesIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6155 14.1676L15.4913 14.1776L16.6113 16.976C16.7813 17.4035 17.2672 17.611 17.6938 17.4401C18.1213 17.2701 18.3288 16.7843 18.158 16.3576L14.8246 8.02429C14.6988 7.70762 14.3922 7.50012 14.0513 7.50012C13.7105 7.50012 13.4038 7.70762 13.278 8.02429L9.94466 16.3576C9.77382 16.7843 9.98132 17.2701 10.4088 17.4401C10.8355 17.611 11.3213 17.4035 11.4913 16.976L12.6155 14.1676ZM13.2813 12.5035L14.8238 12.5085L14.0513 10.5776L13.2813 12.5035ZM7.99625 5.83346C7.57958 6.75262 7.05458 7.70846 6.38541 8.53846C6.11625 8.21262 5.87041 7.86763 5.64541 7.51513C5.39791 7.12679 4.88292 7.01346 4.49458 7.26013C4.10708 7.50763 3.99291 8.02344 4.24041 8.41094C4.53041 8.86594 4.85042 9.30595 5.20375 9.71928C4.45208 10.3068 3.56708 10.721 2.52208 10.8385C2.06458 10.8901 1.73541 11.3035 1.78708 11.7601C1.83874 12.2176 2.25208 12.5468 2.70875 12.4951C4.15125 12.3318 5.36207 11.7235 6.37374 10.8735C7.14874 11.5093 8.04041 12.0076 9.06125 12.2885C9.50458 12.4101 9.96375 12.1493 10.0854 11.706C10.2079 11.2626 9.94625 10.8034 9.50291 10.6809C8.76791 10.4793 8.12041 10.1293 7.55041 9.68513C8.67624 8.33763 9.47624 6.71845 10.0254 5.30095C10.1912 4.87178 9.97792 4.38928 9.54875 4.22261C9.46125 4.18928 9.37125 4.17096 9.28208 4.16763L7.23875 4.16679V3.33346C7.23875 2.87346 6.86542 2.50012 6.40542 2.50012C5.94542 2.50012 5.57208 2.87346 5.57208 3.33346V4.16679H2.61541C2.15541 4.16679 1.78208 4.54012 1.78208 5.00012C1.78208 5.46012 2.15541 5.83346 2.61541 5.83346H7.99625Z"
        fill="#CFCFCF"
      />
    </svg>
  );
};

export const RadioButtonIcon = (props) => {
  return props.active ? (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="5" stroke="white" strokeWidth="5" />
    </svg>
  ) : (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="6.7" stroke="#CFCFCF" strokeWidth="1.6" />
    </svg>
  );
};

export const LocationCardIcon = (props) => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1567 40.9768L21.285 41.0502L21.3363 41.0795C21.5399 41.1896 21.7677 41.2472 21.9991 41.2472C22.2305 41.2472 22.4583 41.1896 22.6618 41.0795L22.7132 41.052L22.8433 40.9768C23.5604 40.5517 24.2601 40.0979 24.9407 39.6165C26.7026 38.3726 28.3489 36.9723 29.8595 35.4328C33.4235 31.7845 37.125 26.3028 37.125 19.25C37.125 15.2386 35.5315 11.3915 32.695 8.55501C29.8585 5.71852 26.0114 4.125 22 4.125C17.9886 4.125 14.1415 5.71852 11.305 8.55501C8.46852 11.3915 6.875 15.2386 6.875 19.25C6.875 26.301 10.5783 31.7845 14.1405 35.4328C15.6505 36.9722 17.2962 38.3725 19.0575 39.6165C19.7387 40.0979 20.439 40.5517 21.1567 40.9768ZM22 24.75C23.4587 24.75 24.8576 24.1705 25.8891 23.1391C26.9205 22.1076 27.5 20.7087 27.5 19.25C27.5 17.7913 26.9205 16.3924 25.8891 15.3609C24.8576 14.3295 23.4587 13.75 22 13.75C20.5413 13.75 19.1424 14.3295 18.1109 15.3609C17.0795 16.3924 16.5 17.7913 16.5 19.25C16.5 20.7087 17.0795 22.1076 18.1109 23.1391C19.1424 24.1705 20.5413 24.75 22 24.75Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const ReviewCardIcon = (props) => {
  return (
    <svg
      width="45"
      height="44"
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4446 5.88493C21.266 3.91043 24.0673 3.91043 24.8886 5.88493L28.7056 15.0626L38.613 15.8583C40.747 16.0288 41.6123 18.6908 39.9861 20.0841L32.4383 26.5503L34.7428 36.2174C35.2396 38.3001 32.9755 39.9446 31.1495 38.8299L22.6666 33.6489L14.1838 38.8299C12.3578 39.9446 10.0937 38.2983 10.5905 36.2174L12.895 26.5503L5.34715 20.0841C3.72098 18.6908 4.58632 16.0288 6.72032 15.8583L16.6276 15.0626L20.4446 5.88493Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const ClockCardIcon = (props) => {
  return (
    <svg
      width="45"
      height="44"
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.3334 4.125C12.4609 4.125 4.45837 12.1275 4.45837 22C4.45837 31.8725 12.4609 39.875 22.3334 39.875C32.2059 39.875 40.2084 31.8725 40.2084 22C40.2084 12.1275 32.2059 4.125 22.3334 4.125ZM23.7084 11C23.7084 10.6353 23.5635 10.2856 23.3056 10.0277C23.0478 9.76987 22.698 9.625 22.3334 9.625C21.9687 9.625 21.619 9.76987 21.3611 10.0277C21.1032 10.2856 20.9584 10.6353 20.9584 11V22C20.9584 22.759 21.5744 23.375 22.3334 23.375H30.5834C30.948 23.375 31.2978 23.2301 31.5556 22.9723C31.8135 22.7144 31.9584 22.3647 31.9584 22C31.9584 21.6353 31.8135 21.2856 31.5556 21.0277C31.2978 20.7699 30.948 20.625 30.5834 20.625H23.7084V11Z"
          fill={props.color || "white"}
        />
      </g>
    </svg>
  );
};

export const GraphProgressionArrow = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49091 5.16914C7.77209 4.88796 8.22797 4.88796 8.50915 5.16914L13.1527 9.81269C13.4339 10.0939 13.4339 10.5497 13.1527 10.8309C12.8715 11.1121 12.1345 10.8309 12.1345 10.8309C10 10 6 10 3.86559 10.8309C3.86559 10.8309 3.12854 11.1121 2.84736 10.8309C2.56618 10.5498 2.56618 10.0939 2.84736 9.8127L7.49091 5.16914Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const RedirectIcon = (props) => {
  return (
    <svg
      width={props.width || "12"}
      height={props.height || "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6666 1.42131L5.10449 6.9834"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M11 1V4.33333"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M7.66699 1L11.0003 1"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M4.33333 1H3C1.89543 1 1 1.89543 1 3V9C1 10.1046 1.89543 11 3 11H9C10.1046 11 11 10.1046 11 9V7.66667"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const EditIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.19922 12.7996H5.59922L11.8992 6.4996C12.2175 6.18134 12.3963 5.74968 12.3963 5.2996C12.3963 4.84951 12.2175 4.41786 11.8992 4.0996C11.581 3.78134 11.1493 3.60254 10.6992 3.60254C10.2491 3.60254 9.81748 3.78134 9.49922 4.0996L3.19922 10.3996V12.7996Z"
        stroke={props.color || "#CFCFCF"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.90039 4.7002L11.3004 7.1002"
        stroke={props.color || "#CFCFCF"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TimeIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2.5C4.6875 2.5 2 5.1875 2 8.5C2 11.8125 4.6875 14.5 8 14.5C11.3125 14.5 14 11.8125 14 8.5C14 5.1875 11.3125 2.5 8 2.5Z"
        stroke={props.color || "#404040"}
        stroke-miterlimit="10"
      />
      {props.showTime === false ? (
        <path
          d="M10 8.5H6"
          stroke={props.color || "#404040"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <path
          d="M7 5.5V9.25L10 10.5"
          stroke={props.color || "#404040"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
};

export const CircleWrongIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4344_31301)">
        <path
          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C3.20021 4.31451 2.75825 4.97595 2.45672 5.7039C2.15519 6.43185 2 7.21207 2 8Z"
          stroke={props.color || "#D0405A"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.6665 6.66699L9.33317 9.33366M9.33317 6.66699L6.6665 9.33366"
          stroke={props.color || "#D0405A"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4344_31301">
          <rect
            width={props.width || "16"}
            height={props.height || "16"}
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CircleTickIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4344_31328)">
        <path
          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C3.20021 4.31451 2.75825 4.97595 2.45672 5.7039C2.15519 6.43185 2 7.21207 2 8Z"
          stroke={props.color || "#CFCFCF"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 8.00033L7.33333 9.33366L10 6.66699"
          stroke={props.color || "#CFCFCF"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4344_31328">
          <rect
            width={props.width || "16"}
            height={props.height || "16"}
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ImportIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.3335 2V4.66667C9.3335 4.84348 9.40373 5.01305 9.52876 5.13807C9.65378 5.2631 9.82335 5.33333 10.0002 5.33333H12.6668"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3335 14H4.66683C4.31321 14 3.97407 13.8595 3.72402 13.6095C3.47397 13.3594 3.3335 13.0203 3.3335 12.6667V3.33333C3.3335 2.97971 3.47397 2.64057 3.72402 2.39052C3.97407 2.14048 4.31321 2 4.66683 2H9.3335L12.6668 5.33333V12.6667C12.6668 13.0203 12.5264 13.3594 12.2763 13.6095C12.0263 13.8595 11.6871 14 11.3335 14Z"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.33301V11.333"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.3335 8.99967L8.00016 7.33301L9.66683 8.99967"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileIcon = (props) => {
  return (
    <svg
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0007 1.66699L10.0982 1.67283C10.2842 1.69476 10.4574 1.77872 10.5898 1.91117C10.7223 2.04361 10.8062 2.21681 10.8282 2.40283L10.834 2.50033V5.83366L10.8382 5.95866C10.868 6.35547 11.0388 6.72851 11.3197 7.01035C11.6006 7.29219 11.9731 7.46421 12.3698 7.49533L12.5007 7.50033H15.834L15.9315 7.50616C16.1175 7.5281 16.2907 7.61206 16.4231 7.7445C16.5556 7.87695 16.6395 8.05015 16.6615 8.23616L16.6673 8.33366V15.8337C16.6674 16.4713 16.4237 17.0849 15.9862 17.5489C15.5488 18.0128 14.9506 18.2921 14.314 18.3295L14.1673 18.3337H5.83398C5.19631 18.3337 4.58272 18.0901 4.11877 17.6526C3.65481 17.2151 3.37556 16.6169 3.33815 15.9803L3.33398 15.8337V4.16699C3.33395 3.52932 3.57759 2.91573 4.01505 2.45177C4.45252 1.98782 5.05074 1.70857 5.68732 1.67116L5.83398 1.66699H10.0007ZM13.0898 10.2445C12.9335 10.0883 12.7216 10.0005 12.5007 10.0005C12.2797 10.0005 12.0678 10.0883 11.9115 10.2445L9.16732 12.9878L8.08982 11.9112C8.01295 11.8316 7.92099 11.7681 7.81932 11.7244C7.71765 11.6807 7.6083 11.6577 7.49765 11.6568C7.387 11.6558 7.27727 11.6769 7.17486 11.7188C7.07244 11.7607 6.9794 11.8226 6.90116 11.9008C6.82291 11.9791 6.76103 12.0721 6.71913 12.1745C6.67723 12.2769 6.65615 12.3867 6.65711 12.4973C6.65807 12.608 6.68106 12.7173 6.72473 12.819C6.76841 12.9207 6.83189 13.0126 6.91148 13.0895L8.57815 14.7562C8.73442 14.9124 8.94635 15.0001 9.16732 15.0001C9.38829 15.0001 9.60021 14.9124 9.75648 14.7562L13.0898 11.4228C13.246 11.2666 13.3338 11.0546 13.3338 10.8337C13.3338 10.6127 13.246 10.4008 13.0898 10.2445ZM12.5007 2.49949L15.834 5.83366H12.5007V2.49949Z"
        fill={props.color || "#CFCFCF"}
      />
    </svg>
  );
};

export const DeleteIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4199 4.41797L11.6006 11.791C11.5218 12.5 10.9224 13.0361 10.209 13.0361H5.78906C5.12033 13.0361 4.5523 12.565 4.41895 11.9219L4.39746 11.791L3.5791 4.41797H12.4199Z"
        stroke={props.color || "white"}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M2.18164 4.18146H5.45437L5.96267 3.33429C6.32412 2.73188 6.97513 2.36328 7.67766 2.36328H8.32199C9.02451 2.36328 9.67553 2.73188 10.037 3.33429L10.5453 4.18146H13.818"
        stroke={props.color || "white"}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M6.38086 6.36328L6.7445 11.0906"
        stroke={props.color || "white"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.6195 6.36328L9.25586 11.0906"
        stroke={props.color || "white"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotInLocationIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.86923 7.86008C7.57595 8.33799 7.45185 8.90063 7.51687 9.45757C7.58189 10.0145 7.83226 10.5334 8.22774 10.9309C8.62322 11.3284 9.14086 11.5814 9.69747 11.6493C10.2541 11.7172 10.8173 11.5959 11.2967 11.3051M12.5009 9.16675C12.5009 8.50371 12.2375 7.86782 11.7687 7.39898C11.2998 6.93014 10.6639 6.66675 10.0009 6.66675"
        stroke={props.color || "#D17541"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2942 14.3017L11.1792 17.4167C10.8667 17.7289 10.443 17.9042 10.0013 17.9042C9.55954 17.9042 9.13587 17.7289 8.82336 17.4167L5.28669 13.8809C4.10824 12.7024 3.41388 11.1254 3.34046 9.46043C3.26704 7.79549 3.81987 6.16343 4.89002 4.88585M6.70669 3.36918C7.97629 2.64843 9.44732 2.36419 10.894 2.56007C12.3408 2.75595 13.6832 3.42114 14.7155 4.45355C15.7477 5.48596 16.4126 6.82856 16.6082 8.27532C16.8039 9.72207 16.5193 11.1931 15.7984 12.4625"
        stroke={props.color || "#D17541"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 2.5L17.5 17.5"
        stroke={props.color || "#D17541"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Indicators = (props) =>
  props.type === "green" ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || "16"}
      height={props.size || "16"}
      viewBox="0 0 16 16"
      fill="none"
      data-cy="green-indicator"
    >
      <circle cx="8" cy="8" r="8" fill="#20C74F" />
    </svg>
  ) : props.type === "grey" ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || "16"}
      height={props.size || "16"}
      viewBox="0 0 16 16"
      fill="none"
      data-cy="grey-indicator"
    >
      <circle cx="8" cy="8" r="8" fill="#6E6E6E" />
    </svg>
  ) : props.type === "red" ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || "16"}
      height={props.size || "16"}
      viewBox="0 0 16 16"
      fill="none"
      data-cy="red-indicator"
    >
      <path d="M8 15L-1.22392e-06 1L16 1L8 15Z" fill="#D0405A" />
    </svg>
  ) : (
    props.type === "yellow" && (
      <svg
        width={props.size || "16"}
        height={props.size || "16"}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 8L8 0L16 8L8 16L0 8Z" fill="#D17541" />
      </svg>
    )
  );

export const UploadIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 4.16797L10 12.0293"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M16.6693 13.334V15.0007C16.6693 15.4609 16.2962 15.834 15.8359 15.834L4.16927 15.834C3.70903 15.834 3.33594 15.4609 3.33594 15.0007L3.33594 13.334"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.16797L13.75 7.38397"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M6.25 7.38397L10 4.16797"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export const GoToLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.6676 3.42131L7.10547 8.9834"
        stroke="var(--tertiaryColor6)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M13 3V6.33333"
        stroke="var(--tertiaryColor6)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M9.66602 3L12.9993 3"
        stroke="var(--tertiaryColor6)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M6.33333 3H5C3.89543 3 3 3.89543 3 5V11C3 12.1046 3.89543 13 5 13H11C12.1046 13 13 12.1046 13 11V9.66667"
        stroke="var(--tertiaryColor6)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const CaptureFallbackIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 22.5C25 23.8261 25.5268 25.0979 26.4645 26.0355C27.4021 26.9732 28.6739 27.5 30 27.5C31.3261 27.5 32.5979 26.9732 33.5355 26.0355C34.4732 25.0979 35 23.8261 35 22.5C35 21.1739 34.4732 19.9021 33.5355 18.9645C32.5979 18.0268 31.3261 17.5 30 17.5C28.6739 17.5 27.4021 18.0268 26.4645 18.9645C25.5268 19.9021 25 21.1739 25 22.5Z"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 20V15C10 13.6739 10.5268 12.4021 11.4645 11.4645C12.4021 10.5268 13.6739 10 15 10H20"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 40V45C10 46.3261 10.5268 47.5979 11.4645 48.5355C12.4021 49.4732 13.6739 50 15 50H20"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40 10H45C46.3261 10 47.5979 10.5268 48.5355 11.4645C49.4732 12.4021 50 13.6739 50 15V20"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 40C20 38.6739 20.5268 37.4021 21.4645 36.4645C22.4021 35.5268 23.6739 35 25 35H35C36.3261 35 37.5979 35.5268 38.5355 36.4645"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.75 52.75L44.75 44.75"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.75 52.75L52.75 44.75"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DotIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="4"
    viewBox="0 0 4 4"
    fill="none"
  >
    <circle cx="2" cy="2" r="2" fill="#6E6E6E" />
  </svg>
);

export const ShareIcon = (props) => {
  return (
    <svg
      width={props.height || "16"}
      height={props.width || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.69584 1.71674C5.8384 1.71674 5.97511 1.77337 6.07591 1.87417C6.17671 1.97497 6.23334 2.11169 6.23334 2.25424C6.23334 2.3968 6.17671 2.53351 6.07591 2.63431C5.97511 2.73511 5.8384 2.79174 5.69584 2.79174H3.18751C2.75984 2.79174 2.3497 2.96163 2.04729 3.26403C1.74489 3.56644 1.575 3.97658 1.575 4.40425V11.9293L1.5836 12.0941C1.6244 12.4911 1.81097 12.8589 2.10724 13.1263C2.4035 13.3937 2.78841 13.5417 3.18751 13.5418H10.7125C11.1402 13.5418 11.5503 13.3719 11.8527 13.0695C12.1551 12.7671 12.325 12.3569 12.325 11.9293V10.4959C12.325 10.3534 12.3817 10.2167 12.4825 10.1159C12.5833 10.0151 12.72 9.95842 12.8625 9.95842C13.0051 9.95842 13.1418 10.0151 13.2426 10.1159C13.3434 10.2167 13.4 10.3534 13.4 10.4959V11.9293C13.4 12.642 13.1169 13.3256 12.6129 13.8296C12.1089 14.3336 11.4253 14.6168 10.7125 14.6168H3.18751C2.49868 14.6168 1.83616 14.3523 1.33671 13.8779C0.837269 13.4035 0.539035 12.7555 0.503583 12.0676L0.5 11.9293V4.40425C0.5 3.69148 0.783147 3.0079 1.28715 2.50389C1.79116 1.99989 2.47473 1.71674 3.18751 1.71674H5.69584ZM9.05487 1.04881C9.14828 1.00603 9.25201 0.990918 9.35375 1.00527C9.45549 1.01962 9.55098 1.06284 9.62892 1.12979L14.6456 5.4298C14.7024 5.47856 14.7484 5.53864 14.7806 5.6062C14.8128 5.67376 14.8306 5.7473 14.8327 5.82212C14.8349 5.89694 14.8214 5.97139 14.7931 6.04069C14.7649 6.11 14.7224 6.17263 14.6685 6.22458L9.65185 11.0621C9.5759 11.1352 9.48014 11.1843 9.37649 11.2034C9.27283 11.2225 9.16586 11.2106 9.06886 11.1694C8.97187 11.1282 8.88914 11.0593 8.83097 10.9714C8.7728 10.8835 8.74175 10.7805 8.74168 10.6751V8.54229C8.01498 8.58815 7.32985 8.73794 6.63468 9.0934C5.82054 9.50979 4.95481 10.2265 3.99089 11.4606L3.79667 11.7143C3.72899 11.8045 3.63462 11.8712 3.52694 11.9048C3.41926 11.9384 3.30372 11.9374 3.1967 11.9017C3.08968 11.866 2.99659 11.7976 2.93063 11.706C2.86467 11.6145 2.82917 11.5046 2.82917 11.3918C2.82917 9.34424 3.32152 7.38558 4.38291 5.92501C5.36904 4.56836 6.82675 3.66966 8.74168 3.52848V1.53757L8.74742 1.45946C8.76038 1.37081 8.79529 1.28681 8.84899 1.21509C8.90268 1.14337 8.97346 1.08621 9.05487 1.04881ZM9.81668 4.04591C9.81668 4.18847 9.76005 4.32518 9.65925 4.42598C9.55845 4.52678 9.42174 4.58341 9.27918 4.58341C7.44666 4.58341 6.12943 5.35025 5.25294 6.5564C4.62371 7.42213 4.21091 8.53225 4.02242 9.77639C4.73909 9.02532 5.43928 8.49714 6.14519 8.13522C7.20801 7.5927 8.24001 7.45009 9.27918 7.45009C9.42174 7.45009 9.55845 7.50671 9.65925 7.60752C9.76005 7.70832 9.81668 7.84503 9.81668 7.98759V9.40946L13.4968 5.86052L9.81668 2.70574V4.04591Z"
        fill={props.color || "var(--tertiaryColor6)"}
      />
    </svg>
  );
};

export const CopyIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6065_10349)">
        <path
          d="M4.66602 6.44402C4.66602 5.97246 4.85334 5.52022 5.18678 5.18678C5.52022 4.85334 5.97246 4.66602 6.44402 4.66602H12.2213C12.4548 4.66602 12.686 4.71201 12.9018 4.80136C13.1175 4.89071 13.3135 5.02168 13.4786 5.18678C13.6437 5.35188 13.7747 5.54789 13.864 5.7636C13.9534 5.97932 13.9993 6.21053 13.9993 6.44402V12.2213C13.9993 12.4548 13.9534 12.686 13.864 12.9018C13.7747 13.1175 13.6437 13.3135 13.4786 13.4786C13.3135 13.6437 13.1175 13.7747 12.9018 13.864C12.686 13.9534 12.4548 13.9993 12.2213 13.9993H6.44402C6.21053 13.9993 5.97932 13.9534 5.7636 13.864C5.54789 13.7747 5.35188 13.6437 5.18678 13.4786C5.02168 13.3135 4.89071 13.1175 4.80136 12.9018C4.71201 12.686 4.66602 12.4548 4.66602 12.2213V6.44402Z"
          stroke={"var(--tertiaryColor6)" || props.color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.67467 11.158C2.47023 11.0415 2.30018 10.873 2.18172 10.6697C2.06325 10.4663 2.00057 10.2353 2 10V3.33333C2 2.6 2.6 2 3.33333 2H10C10.5 2 10.772 2.25667 11 2.66667"
          stroke={"var(--tertiaryColor6)" || props.color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6065_10349">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MenuOptionsIcon = (props) => {
  return (
    <svg
      width={props?.width ? props?.width : "12"}
      height={props?.height ? props?.height : "5"}
      viewBox="0 0 12 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.606061C0 0.271343 0.244208 0 0.545455 0H11.4545C11.7558 0 12 0.271343 12 0.606061C12 0.940779 11.7558 1.21212 11.4545 1.21212L0.545455 1.21212C0.244208 1.21212 0 0.940779 0 0.606061Z"
        fill={props?.color ? props?.color : "#CFCFCF"}
      />
      <path
        d="M0 4.39394C0 4.05922 0.244208 3.78788 0.545455 3.78788H11.4545C11.7558 3.78788 12 4.05922 12 4.39394C12 4.72866 11.7558 5 11.4545 5H0.545455C0.244208 5 0 4.72866 0 4.39394Z"
        fill={props?.color ? props?.color : "#CFCFCF"}
      />
    </svg>
  );
};

export const SettingsIcon = (props) => {
  return (
    <svg
      width={props?.width ? props?.width : "20px"}
      height={props?.height ? props?.height : "20px"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6610_10358)">
        <path
          d="M16.5625 5.225C16.8489 5.38788 17.0867 5.62414 17.2515 5.90946C17.4163 6.19478 17.5021 6.51886 17.5 6.84833V12.9183C17.5 13.5925 17.1308 14.2142 16.535 14.5417L10.91 18.1C10.6311 18.2531 10.3181 18.3334 10 18.3334C9.68186 18.3334 9.36887 18.2531 9.09 18.1L3.465 14.5417C3.17347 14.3824 2.9301 14.1476 2.76034 13.8621C2.59058 13.5765 2.50067 13.2506 2.5 12.9183V6.8475C2.5 6.17333 2.86917 5.5525 3.465 5.225L9.09 1.90833C9.37711 1.75003 9.69964 1.66701 10.0275 1.66701C10.3554 1.66701 10.6779 1.75003 10.965 1.90833L16.59 5.225H16.5625Z"
          stroke={props?.color ? props?.color : "#CFCFCF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 10C7.5 10.663 7.76339 11.2989 8.23223 11.7678C8.70107 12.2366 9.33696 12.5 10 12.5C10.663 12.5 11.2989 12.2366 11.7678 11.7678C12.2366 11.2989 12.5 10.663 12.5 10C12.5 9.33696 12.2366 8.70107 11.7678 8.23223C11.2989 7.76339 10.663 7.5 10 7.5C9.33696 7.5 8.70107 7.76339 8.23223 8.23223C7.76339 8.70107 7.5 9.33696 7.5 10Z"
          stroke={props?.color ? props?.color : "#CFCFCF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6610_10358">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SupportIcon = (props) => {
  return (
    <svg
      width={props?.width ? props?.width : "20px"}
      height={props?.height ? props?.height : "20px"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16667 10.8333V9.16667C4.16667 6.86548 6.03215 5 8.33333 5H11.6667C13.9679 5 15.8333 6.86548 15.8333 9.16667V10.8333"
        stroke={props?.color ? props?.color : "#CFCFCF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16667 10.8333C3.24619 10.8333 2.5 11.5795 2.5 12.5V13.3333C2.5 14.2538 3.24619 15 4.16667 15C5.08714 15 5.83333 14.2538 5.83333 13.3333V12.5C5.83333 11.5795 5.08714 10.8333 4.16667 10.8333Z"
        stroke={props?.color ? props?.color : "#CFCFCF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8333 10.8333C14.9129 10.8333 14.1667 11.5795 14.1667 12.5V13.3333C14.1667 14.2538 14.9129 15 15.8333 15C16.7538 15 17.5 14.2538 17.5 13.3333V12.5C17.5 11.5795 16.7538 10.8333 15.8333 10.8333Z"
        stroke={props?.color ? props?.color : "#CFCFCF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8333 15V15.8333C15.8333 17.0217 14.855 18 13.6667 18H10.8333"
        stroke={props?.color ? props?.color : "#CFCFCF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16667 16.6667H10.8333C11.2936 16.6667 11.6667 17.0398 11.6667 17.5C11.6667 17.9602 11.2936 18.3333 10.8333 18.3333H9.16667C8.70643 18.3333 8.33333 17.9602 8.33333 17.5C8.33333 17.0398 8.70643 16.6667 9.16667 16.6667Z"
        stroke={props?.color ? props?.color : "#CFCFCF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SendIcon = (props) => {
  return (
    <svg
      width={props?.width ? props?.width : "16"}
      height={props?.height ? props?.height : "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 1.33333L7.33333 8.66667"
        stroke={props?.color ? props?.color : "#FFFFFF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 1.33333L10 14.6667L7.33333 8.66667L1.33333 6L14.6667 1.33333Z"
        stroke={props?.color ? props?.color : "#FFFFFF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExportLinkIcon = (props) => {
  return (
    <svg
      width={props?.width ? props?.width : "16"}
      height={props?.height ? props?.height : "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6666 3.42106L7.10449 8.98315"
        stroke={props?.color ? props?.color : "#CFCFCF"}
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M13 3V6.33333"
        stroke={props?.color ? props?.color : "#CFCFCF"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M9.66699 3L13.0003 3"
        stroke={props?.color ? props?.color : "#CFCFCF"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M6.33333 3H5C3.89543 3 3 3.89543 3 5V11C3 12.1046 3.89543 13 5 13H11C12.1046 13 13 12.1046 13 11V9.66667"
        stroke={props?.color ? props?.color : "#CFCFCF"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const NoVideoCameraIcon = (props) => {
  return (
    <svg
      width={props?.width ? props?.width : "16"}
      height={props?.height ? props?.height : "16"}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7017_13545)">
        <path
          d="M5 5L35 35"
          stroke={props?.color ? props?.color : "#CFCFCF"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25 18.3333V16.6666L32.5883 12.8733C32.8424 12.7463 33.1246 12.6864 33.4083 12.6992C33.692 12.712 33.9677 12.797 34.2093 12.9463C34.4509 13.0956 34.6504 13.3041 34.7888 13.5521C34.9271 13.8001 34.9998 14.0793 35 14.3633V25.6366C35.0001 25.9839 34.8917 26.3225 34.69 26.6051C34.4883 26.8878 34.2034 27.1004 33.875 27.2133"
          stroke={props?.color ? props?.color : "#CFCFCF"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6667 10H21.6667C22.5507 10 23.3986 10.3512 24.0237 10.9763C24.6488 11.6014 25 12.4493 25 13.3333V18.3333M25 25V26.6667C25 27.5507 24.6488 28.3986 24.0237 29.0237C23.3986 29.6488 22.5507 30 21.6667 30H8.33333C7.44928 30 6.60143 29.6488 5.97631 29.0237C5.35119 28.3986 5 27.5507 5 26.6667V13.3333C5 12.4493 5.35119 11.6014 5.97631 10.9763C6.60143 10.3512 7.44928 10 8.33333 10H10"
          stroke={props?.color ? props?.color : "#CFCFCF"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7017_13545">
          <rect
            width={props?.width ? props?.width : "16"}
            height={props?.height ? props?.height : "16"}
            fill={props?.color ? props?.color : "white"}
          />
        </clipPath>
      </defs>
    </svg>
  );
};
